/* @checkout-sdk/pay version ' + 0.0.3 */
import { env, axios, getAdapter, initAdapter, ZYToast } from '@zyf2e/adapt';

var ROUTE_PATH = {
    checkout: '/checkout',
    confirm: '/confirm',
    success: '/success',
    fail: '/fail'
};

var iconAlipay = 'https://static.91jkys.com/attachment/20210629101054066_4a6530d8cfc742239c577fd3f372074f.png';
var iconWepay = 'https://static.91jkys.com/attachment/20210629101058690_0b872db7d0254ab08f8582ddaf28bb1d.png';
var iconUnion = 'https://static.91jkys.com/attachment/20210629101101851_55f47d3d8e6744ad98f6ee285c609b54.png';
var iconInsure = 'https://kit-static.91jkys.com/attachment/kit-server/ca934dad669f4e28a0a5fbe880d0bbb37b04a42f4d443151c276956d659b5076.png';
var payClients = [
    {
        value: 'alipay',
        name: '支付宝',
        icon: iconAlipay
    },
    {
        value: 'wechat',
        name: '微信',
        icon: iconWepay
    },
    {
        value: 'union',
        name: '银联支付',
        icon: iconUnion
    },
    {
        value: 'nx_insure_pay',
        name: '医保',
        icon: iconInsure
    }
];
function getPayClient(client) {
    return (payClients.find(function (item) { return item.value === client; }) || {
        value: '',
        name: '其他支付',
        icon: ''
    });
}
var mallSassPayList = [
    {
        id: 1,
        name: '微信支付',
        icon: iconWepay
    }
];
function getMallSassPayClient(id) {
    return mallSassPayList.find(function (item) { return item.id === id; }) || {};
}

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function getCommonApi(apiUrl, port, rootUrl) {
    if (rootUrl === void 0) { rootUrl = '/'; }
    var devEnv = env.devEnv;
    var protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
    var baseApi = protocol + "//" + apiUrl + (devEnv ? "." + devEnv : '') + ".91jkys.com";
    return baseApi + (port && port !== 80 ? ":" + port : '') + rootUrl;
}
function getQueryVariable(variable) {
    var query = window.location.href.split('?');
    if (query.length < 2) {
        return null;
    }
    var vars = query[1].split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return null;
}
function parseParam(json) {
    return Object.keys(json)
        .map(function (v) {
        if (/^https?:\/\//.test(json[v])) {
            return v + "=" + encodeURIComponent(json[v]);
        }
        if (!json[v])
            return '';
        return v + "=" + json[v];
    })
        .filter(function (item) { return item; })
        .join('&');
}
function callBackUrl(domain, params) {
    return domain + "#" + ROUTE_PATH.confirm + "?" + parseParam(params);
}
function getUCLoginUrl() {
    var hostStr = window.location.host;
    if (/\.qa\.|\d+\.\d+\.|localhost/.test(hostStr)) {
        return 'https://third.y.91jkys.com/api/share-login-center/';
    }
    if (/\.pre\./.test(hostStr)) {
        return 'https://third.pre.91jkys.com/share-login-center/';
    }
    return 'https://share-login-center.91jkys.com/';
}
function baseOfWechat(configKey, pw) {
    var url = window.location.href + "&payWay=" + pw;
    window.location.replace(getUCLoginUrl() + "weChat/getOpenId?redirectUrl=" + encodeURIComponent(url) + "&configKey=" + configKey);
}
function getAppPayString(payString) {
    var ua = window.navigator.userAgent;
    return !/flutter/i.test(ua) && /iPhone|iPad|iPod/i.test(ua) ? encodeURIComponent(payString) : payString;
}
function getPayUa() {
    if (env.inWechatMiniProgram) {
        return 'mini';
    }
    if (env.inWechat) {
        return 'pub';
    }
    if (env.inAPP) {
        return 'app';
    }
    if (env.inH5 || env.inAliApp) {
        return 'h5';
    }
    return 'pc';
}
function getPaymentParams(payString, paramKeys) {
    return paramKeys.reduce(function (params, key) {
        var _a;
        var val = getParamByName(payString, key);
        return __assign(__assign({}, params), (_a = {}, _a[key] = val, _a));
    }, { signType: 'RSA' });
}
function getParamByName(str, name) {
    var reg = new RegExp("[^?,]?" + name + "=([^,]+)");
    var target = str.match(reg);
    if (target && target.length > 1) {
        return target[1];
    }
    return '';
}
function getQueryValues(queryKeys) {
    var query = window.location.search.substring(1) + '&' + window.location.hash.split('?')[1];
    var vars = query.split('&');
    var result = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (queryKeys.includes(pair[0])) {
            result[pair[0]] = pair[1];
        }
    }
    return result;
}
function getMallTradeType() {
    if (env.inAPP) {
        return EMallSassTradeType.APP;
    }
    else if (env.inWechat) {
        return EMallSassTradeType.OFFICIAL;
    }
    return EMallSassTradeType.H5;
}
function replace(url) {
    if (env.inAPP) {
        Sailer.replace(url);
    }
    else {
        location.replace(url);
    }
}
function isWxH5Pay(payUA, payChannel, payStringJson) {
    return payUA === 'h5' && payChannel === 'wxpay_ecommerce' && payStringJson && (JSON.parse(payStringJson) || {}).wx_wap;
}

function mallRequestResult(res) {
    return new Promise(function (resolve, reject) {
        var result = res !== undefined ? JSON.parse(res) : res;
        if (result.code === 0) {
            resolve(result.data);
        }
        else {
            reject(result);
        }
    });
}

var adaptConfig = {
    INSURANCE: {
        baseURL: process.env.VUE_APP_INSURANCE_API,
        loginKey: process.env.VUE_APP_INSURANCE_LOGIN_KEY,
        wechatLoginApi: process.env.VUE_APP_INSURANCE_LOGIN_API,
        h5LoginUrl: process.env.VUE_APP_INSURANCE_H5LOGIN_URL + "#/login?c=" + getQueryVariable('city') + "&redirect=",
        jkysWechatURL: process.env.VUE_APP_INSURANCE_API + "cis_base/1.0/get_wxconfig?c=" + getQueryVariable('city')
    }
};
var PAY_WAY = {
    alipay_app: 'aliPay',
    union_pay_app: 'yinLianPay',
    wechat_app: 'wxpay'
};
var EventTypeEnum;
(function (EventTypeEnum) {
    EventTypeEnum[EventTypeEnum["jump"] = 0] = "jump";
    EventTypeEnum[EventTypeEnum["closeWindow"] = 1] = "closeWindow";
})(EventTypeEnum || (EventTypeEnum = {}));
var EPayResult;
(function (EPayResult) {
    EPayResult["success"] = "pay_success";
    EPayResult["fail"] = "pay_fail";
    EPayResult["cancel"] = "pay_cancel";
    EPayResult["invalid"] = "pay_invalid";
    EPayResult["ok"] = "pay_success";
    EPayResult[EPayResult["pay_fail"] = 0] = "pay_fail";
    EPayResult[EPayResult["pay_success"] = 1] = "pay_success";
    EPayResult[EPayResult["pay_invalid"] = 2] = "pay_invalid";
})(EPayResult || (EPayResult = {}));
var EPingPayWay;
(function (EPingPayWay) {
    EPingPayWay["wechatPub"] = "wechat_pub";
    EPingPayWay["wechatH5"] = "wechat_h5";
    EPingPayWay["unionPayH5"] = "union_pay_h5";
    EPingPayWay["alipayH5"] = "alipay_h5";
})(EPingPayWay || (EPingPayWay = {}));
var NX_INSURE_PUB = 'nx_insure_pub';
var EQRCodePayWay;
(function (EQRCodePayWay) {
    EQRCodePayWay["wx_pub_qr"] = "wechat";
    EQRCodePayWay["alipay_qr"] = "alipay";
})(EQRCodePayWay || (EQRCodePayWay = {}));
var EMallSassTradeType;
(function (EMallSassTradeType) {
    EMallSassTradeType["APP"] = "APP";
    EMallSassTradeType["OFFICIAL"] = "OFFICIAL";
    EMallSassTradeType["H5"] = "H5";
})(EMallSassTradeType || (EMallSassTradeType = {}));
var MALL_SASS_SUBMIT_PAY_OVER_TIME = 410203;
var PAY_ERROR;
(function (PAY_ERROR) {
    PAY_ERROR["initAdaptError"] = "INIT_ADAPT_ERROR";
})(PAY_ERROR || (PAY_ERROR = {}));
var ERROR_MESSAGE = {
    pay_cancel: '支付取消',
    pay_fail: '支付失败',
    pay_invalid: '未检测到安装应用'
};

function getTradeInfo(tradeNo) {
    try {
        return axios.post('trade-service/1.0.0/getTradeInfo', {
            tradeNo: tradeNo
        });
    }
    catch (error) {
        return Promise.reject(PAY_ERROR.initAdaptError);
    }
}
function getPayResult(tradeNo, queryThirdPlatform) {
    try {
        return axios.post('trade-service/1.0.0/queryPayResult', {
            tradeNo: tradeNo,
            queryThirdPlatform: queryThirdPlatform
        });
    }
    catch (error) {
        return Promise.reject(PAY_ERROR.initAdaptError);
    }
}
function getPayConfig(tradeNo, payUA) {
    try {
        return axios.post('trade-service/1.0.0/getPayConfig', {
            tradeNo: tradeNo,
            payUA: payUA
        });
    }
    catch (error) {
        return Promise.reject(PAY_ERROR.initAdaptError);
    }
}
function getRedirectUrl(redirectUrl) {
    try {
        return axios.get('/trade-service/1.0.0/getRedirectUrlKey', { params: { redirectUrl: redirectUrl } });
    }
    catch (error) {
        return Promise.reject(PAY_ERROR.initAdaptError);
    }
}
function getOpenId(params) {
    try {
        return axios.post('/trade-service/1.0.0/queryOpenId', params);
    }
    catch (error) {
        return Promise.reject(PAY_ERROR.initAdaptError);
    }
}
function getPayString(params) {
    try {
        return axios.post('/trade-service/1.0.0/prePay', params);
    }
    catch (error) {
        return Promise.reject(PAY_ERROR.initAdaptError);
    }
}
function getNoLoginOpenId(params) {
    try {
        return axios.post('/trade-service/1.0.0/getWechatInfoNologin', params);
    }
    catch (error) {
        return Promise.reject(PAY_ERROR.initAdaptError);
    }
}

function getMallSaasDetail(params) {
    return axios.post('/mall-saas/1.0.0/detail', params)
        .then(function (res) { return mallRequestResult(res); });
}
function getMallSaasPay(params) {
    return axios.post('/mall-saas/1.0.0/pay', params)
        .then(function (res) { return mallRequestResult(res); });
}
function getMallSaasPayResult(params) {
    return axios.post('/mall-saas/1.0.0/payResult', params)
        .then(function (res) { return mallRequestResult(res); });
}

var ERROR_TYPE;
(function (ERROR_TYPE) {
    ERROR_TYPE["error"] = "ERROR";
    ERROR_TYPE["errorDialog"] = "ERROR_DIALOG";
    ERROR_TYPE["errorPay"] = "ERROR_PAY";
    ERROR_TYPE["errorNotSupport"] = "ERROR_NOT_SUPPORT";
})(ERROR_TYPE || (ERROR_TYPE = {}));
var CheckoutError = (function (_super) {
    __extends(CheckoutError, _super);
    function CheckoutError(message, type, code) {
        if (type === void 0) { type = ERROR_TYPE.error; }
        if (code === void 0) { code = ''; }
        var _this = _super.call(this) || this;
        _this.message = message;
        _this.type = type;
        _this.code = code;
        return _this;
    }
    return CheckoutError;
}(Error));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var telescope_min = createCommonjsModule(function (module, exports) {
(function (global, factory) {
    factory(exports) ;
}(commonjsGlobal, function (exports) {    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/log_h5.gif";
    var DEBUG_SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/f2e/log.gif";
    var BEAT_SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/beat.gif";
    var DURATION_SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/duration.gif";
    var CUSTOM_TOKEN_KEY = 'TRYCATCH_TOKEN';
    var SEND_TYPE = {
        SYNC: 'SYNC',
        ASYNC: 'ASYNC',
        UNLOAD: 'UNLOAD'
    };
    var ACTION_TYPE = {
        EVENT: 'EVENT',
        PAGE: 'PAGE',
        VIEW: 'VIEW',
        DURATION: 'DURATION',
        VIEW_DURATION: 'VIEW_DURATION'
    };
    var SAFETY_KEY = [
        'version',
        'custom',
        'actionType',
        'eventName',
        'pageId',
        'domId',
        'domClass',
        'domHref',
        'domName',
        'domTag',
        'domContent',
        'domPath',
        'trackId',
        'referrerId',
        'score',
        'startTime',
        'endTime',
        'durationTime',
        'channel',
        'netType',
        'debug',
        'seKeywords',
        'bizId',
        'isAutoTrack',
        'autoTrackId',
        'contentId',
        'patientId',
        'doctorId',
        'skuId',
        'prescriptionId',
        'storeId',
        'inquiryId',
        'orderId',
        'activityId'
    ];
    function _isPlaceholder(a) {
      return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }
    var _isPlaceholder_1 = _isPlaceholder;
    function _curry1(fn) {
      return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder_1(a)) {
          return f1;
        } else {
          return fn.apply(this, arguments);
        }
      };
    }
    var _curry1_1 = _curry1;
    function _curry2(fn) {
      return function f2(a, b) {
        switch (arguments.length) {
          case 0:
            return f2;
          case 1:
            return _isPlaceholder_1(a) ? f2 : _curry1_1(function (_b) {
              return fn(a, _b);
            });
          default:
            return _isPlaceholder_1(a) && _isPlaceholder_1(b) ? f2 : _isPlaceholder_1(a) ? _curry1_1(function (_a) {
              return fn(_a, b);
            }) : _isPlaceholder_1(b) ? _curry1_1(function (_b) {
              return fn(a, _b);
            }) : fn(a, b);
        }
      };
    }
    var _curry2_1 = _curry2;
    function _arrayFromIterator(iter) {
      var list = [];
      var next;
      while (!(next = iter.next()).done) {
        list.push(next.value);
      }
      return list;
    }
    var _arrayFromIterator_1 = _arrayFromIterator;
    function _includesWith(pred, x, list) {
      var idx = 0;
      var len = list.length;
      while (idx < len) {
        if (pred(x, list[idx])) {
          return true;
        }
        idx += 1;
      }
      return false;
    }
    var _includesWith_1 = _includesWith;
    function _functionName(f) {
      var match = String(f).match(/^function (\w*)/);
      return match == null ? '' : match[1];
    }
    var _functionName_1 = _functionName;
    function _has(prop, obj) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var _has_1 = _has;
    function _objectIs(a, b) {
      if (a === b) {
        return a !== 0 || 1 / a === 1 / b;
      } else {
        return a !== a && b !== b;
      }
    }
    var _objectIs_1 = typeof Object.is === 'function' ? Object.is : _objectIs;
    var toString = Object.prototype.toString;
    var _isArguments =
    function () {
      return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString.call(x) === '[object Arguments]';
      } : function _isArguments(x) {
        return _has_1('callee', x);
      };
    }();
    var _isArguments_1 = _isArguments;
    var hasEnumBug = !
    {
      toString: null
    }.propertyIsEnumerable('toString');
    var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
    var hasArgsEnumBug =
    function () {
      return arguments.propertyIsEnumerable('length');
    }();
    var contains = function contains(list, item) {
      var idx = 0;
      while (idx < list.length) {
        if (list[idx] === item) {
          return true;
        }
        idx += 1;
      }
      return false;
    };
    var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ?
    _curry1_1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    _curry1_1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
      var prop, nIdx;
      var ks = [];
      var checkArgsLength = hasArgsEnumBug && _isArguments_1(obj);
      for (prop in obj) {
        if (_has_1(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];
          if (_has_1(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }
          nIdx -= 1;
        }
      }
      return ks;
    });
    var keys_1 = keys;
    var type =
    _curry1_1(function type(val) {
      return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
    });
    var type_1 = type;
    function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
      var a = _arrayFromIterator_1(aIterator);
      var b = _arrayFromIterator_1(bIterator);
      function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
      }
      return !_includesWith_1(function (b, aItem) {
        return !_includesWith_1(eq, aItem, b);
      }, b, a);
    }
    function _equals(a, b, stackA, stackB) {
      if (_objectIs_1(a, b)) {
        return true;
      }
      var typeA = type_1(a);
      if (typeA !== type_1(b)) {
        return false;
      }
      if (a == null || b == null) {
        return false;
      }
      if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
        return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
      }
      if (typeof a.equals === 'function' || typeof b.equals === 'function') {
        return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
      }
      switch (typeA) {
        case 'Arguments':
        case 'Array':
        case 'Object':
          if (typeof a.constructor === 'function' && _functionName_1(a.constructor) === 'Promise') {
            return a === b;
          }
          break;
        case 'Boolean':
        case 'Number':
        case 'String':
          if (!(typeof a === typeof b && _objectIs_1(a.valueOf(), b.valueOf()))) {
            return false;
          }
          break;
        case 'Date':
          if (!_objectIs_1(a.valueOf(), b.valueOf())) {
            return false;
          }
          break;
        case 'Error':
          return a.name === b.name && a.message === b.message;
        case 'RegExp':
          if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
            return false;
          }
          break;
      }
      var idx = stackA.length - 1;
      while (idx >= 0) {
        if (stackA[idx] === a) {
          return stackB[idx] === b;
        }
        idx -= 1;
      }
      switch (typeA) {
        case 'Map':
          if (a.size !== b.size) {
            return false;
          }
          return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
        case 'Set':
          if (a.size !== b.size) {
            return false;
          }
          return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
          break;
        default:
          return false;
      }
      var keysA = keys_1(a);
      if (keysA.length !== keys_1(b).length) {
        return false;
      }
      var extendedStackA = stackA.concat([a]);
      var extendedStackB = stackB.concat([b]);
      idx = keysA.length - 1;
      while (idx >= 0) {
        var key = keysA[idx];
        if (!(_has_1(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
          return false;
        }
        idx -= 1;
      }
      return true;
    }
    var _equals_1 = _equals;
    var equals =
    _curry2_1(function equals(a, b) {
      return _equals_1(a, b, [], []);
    });
    var equals_1 = equals;
    function isThenable(f) {
        return f && typeof f.then === 'function';
    }
    function getQueryVariable(variable) {
        var query = window.location.href.match(/\?(.*)$/);
        if (!query)
            return null;
        var vars = query[1].split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return null;
    }
    function getCookie(name) {
        var cookies = document.cookie.split(';');
        for (var i in cookies) {
            var arr = cookies[i].split('=');
            if (name == arr[0].trim()) {
                return unescape(arr[1]).replace(/&&&&/g, ';');
            }
        }
        return null;
    }
    function setCookie(name, value, expires, path, domain) {
        if (expires === void 0) { expires = 99999; }
        if (path === void 0) { path = '/'; }
        document.cookie =
            name +
                '=' +
                value.replace(/;/g, '&&&&') +
                (expires ? '; expires=' + getExpires(expires) : '') +
                (path ? '; path=' + path : '') +
                ('; domain=' + (domain ? domain : '.' + location.host.replace(/.*\.(.*\..*)$/, '$1')));
        function getExpires(hours) {
            var date = new Date();
            date.setTime(date.getTime() + hours * 60 * 60 * 1000);
            return date.toUTCString();
        }
    }
    function notChanged(binding) {
        if (binding.oldValue !== undefined) {
            if (typeof binding.value === 'object') {
                return equals_1(binding.value, binding.oldValue);
            }
            else {
                return binding.value === binding.oldValue;
            }
        }
        else {
            return false;
        }
    }
    function isEmpty(binding) {
        return binding.value === '' || binding.value === undefined || binding.value === null;
    }
    function setFlag(key, value) {
        if (value === void 0) { value = true; }
        _TrackerGlobalData._trackerFlag = _TrackerGlobalData._trackerFlag || {};
        _TrackerGlobalData._trackerFlag[key] = value;
    }
    function getFlag(key) {
        _TrackerGlobalData._trackerFlag = _TrackerGlobalData._trackerFlag || {};
        return _TrackerGlobalData._trackerFlag[key] || false;
    }
    function getUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    function getDomPath(dom) {
        var path = [];
        if (dom.id && typeof dom.id === 'string') {
            path.push('#' + dom.id);
        }
        else if (dom.className && typeof dom.className === 'string') {
            path.push(dom.tagName.toLowerCase() + '.' + dom.className.split(' ')[0]);
        }
        else {
            path.push(dom.tagName.toLowerCase());
        }
        while (dom.parentNode &&
            dom.parentNode.tagName &&
            dom.parentNode.tagName !== 'BODY' &&
            !dom.id) {
            dom = dom.parentNode;
            if (dom.id && typeof dom.id === 'string') {
                path.unshift('#' + dom.id);
            }
            else if (dom.className && typeof dom.className === 'string') {
                path.unshift(dom.tagName.toLowerCase() + '.' + dom.className.split(' ')[0]);
            }
            else {
                path.unshift(dom.tagName.toLowerCase());
            }
        }
        return path.join('>');
    }
    function getLocationHref() {
        if (typeof document === 'undefined' || document.location == null)
            return '';
        return document.location.href;
    }
    function isObject(o) {
        return Object.prototype.toString.call(o) === '[object Object]';
    }
    function hashCode(str) {
        var hash = 0;
        if (!str || str.length === 0) {
            return '';
        }
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash;
        }
        return String(hash).replace('-', '0');
    }
    function getRealPath(url, offlineUrl) {
        if (/file:/.test(url) && offlineUrl) {
            url = offlineUrl + url.replace(/^.*(#.*)$/, '$1');
        }
        return url
            .replace('https', 'http')
            .replace(/\?.*$/, '')
            .replace(/\/\d+([\/]*$)/, '{param}$1')
            .replace(/index\.html/, '')
            .trim();
    }
    var inMin = /miniprogram/i.test(window.navigator.userAgent);
    var inWechat = !inMin && /micromessenger/i.test(window.navigator.userAgent);
    var getReferrerId = function () {
        var urlInfoStr = getQueryVariable('telescope-info');
        var urlInfo = {};
        if (urlInfoStr) {
            try {
                urlInfo = JSON.parse(decodeURIComponent(urlInfoStr));
                return urlInfo.referrerId;
            }
            catch (error) { }
        }
        try {
            var referrerId = getQueryVariable('referrer_id');
            if (referrerId) {
                return referrerId;
            }
            else {
                var referrerInfo = JSON.parse(localStorage.getItem('referrer_id'));
                return referrerInfo ? referrerInfo.referrerId : null;
            }
        }
        catch (error) {
            return null;
        }
    };
    var setReferrerId = function (type) {
        try {
            var pageInfo_1 = getPageInfo();
            var referrerInfo = JSON.parse(localStorage.getItem('referrer_id')) || {
                pageId: pageInfo_1.pageId,
                referrerId: '',
                date: Date.now()
            };
            switch (type) {
                case 'UPDATE':
                    referrerInfo.date = Date.now();
                    referrerInfo.referrerId = referrerInfo.date + 5000 > Date.now() ? referrerInfo.pageId : '';
                    referrerInfo.pageId = '';
                    break;
                case 'BEAT':
                    referrerInfo.pageId = pageInfo_1.pageId;
                    referrerInfo.date = Date.now();
                    break;
            }
            localStorage.setItem('referrer_id', JSON.stringify(referrerInfo));
            setPageInfo({});
        }
        catch (error) { }
    };
    var getSourceEventId = function () {
        var urlInfoStr = getQueryVariable('telescope-info');
        var urlInfo = {};
        if (urlInfoStr) {
            try {
                urlInfo = JSON.parse(decodeURIComponent(urlInfoStr));
                return urlInfo.sourceEventId;
            }
            catch (error) { }
        }
        try {
            var sourceEventInfo = JSON.parse(localStorage.getItem('source_event_id'));
            if (sourceEventInfo.date + 5000 > Date.now()) {
                return sourceEventInfo.sourceEventId;
            }
            return null;
        }
        catch (e) {
            return null;
        }
    };
    var setSourceEventId = function (type, data) {
        var preSourceEventInfo = null;
        try {
            preSourceEventInfo = JSON.parse(localStorage.getItem('source_event_id'));
            switch (type) {
                case 'UPDATE':
                    preSourceEventInfo = {
                        sourceEventId: preSourceEventInfo && preSourceEventInfo.date + 5000 > Date.now() ? preSourceEventInfo.recentId : '',
                        recentId: (preSourceEventInfo && preSourceEventInfo.recentId) || '',
                        date: Date.now(),
                        isAutoTrack: false,
                        url: location.href
                    };
                    localStorage.setItem('source_event_id', JSON.stringify(preSourceEventInfo));
                    break;
                case 'RECORD':
                    if (data && data.actionType === ACTION_TYPE.EVENT && !data.debug) {
                        if (!preSourceEventInfo || preSourceEventInfo.isAutoTrack || preSourceEventInfo.date < Date.now() - 500) {
                            localStorage.setItem('source_event_id', JSON.stringify({
                                date: Date.now(),
                                isAutoTrack: data.isAutoTrack,
                                url: location.href,
                                sourceEventId: preSourceEventInfo ? preSourceEventInfo.sourceEventId : '',
                                recentId: data.trackId
                            }));
                        }
                    }
                    break;
            }
            setPageInfo({});
        }
        catch (error) { }
    };
    var pageInfo = {
        pageId: null,
        referrerId: getReferrerId(),
        sourceEventId: getSourceEventId(),
        referrerUrl: document.referrer || '',
        url: location.href,
        host: location.host,
        path: location.pathname,
        hash: location.hash,
        title: document.title || ''
    };
    var setPageInfo = function (info) {
        if (info.sourceEventId) {
            localStorage.setItem('source_event_id', JSON.stringify({
                date: Date.now(),
                isAutoTrack: false,
                url: '',
                sourceEventId: info.sourceEventId,
                recentId: info.sourceEventId
            }));
        }
        if (info.referrerId) {
            localStorage.setItem('referrer_id', JSON.stringify({
                pageId: info.referrerId,
                referrerId: info.referrerId,
                date: Date.now()
            }));
        }
        pageInfo = __assign(__assign(__assign({}, pageInfo), { url: location.href, host: location.host, path: location.pathname, hash: location.hash, title: document.title || '', referrerId: getReferrerId(), sourceEventId: getSourceEventId() }), info);
    };
    var getPageInfo = function () {
        return __assign({}, pageInfo);
    };
    var config = {
        trackKey: '',
        serverUrl: SERVER_URL,
        debugServerUrl: DEBUG_SERVER_URL,
        beatServerUrl: BEAT_SERVER_URL,
        durationServerUrl: DURATION_SERVER_URL,
        version: null,
        offlineUrl: '',
        sendType: SEND_TYPE.ASYNC,
        delayTime: 50,
        autoTrackPage: true,
        autoTrackClick: true,
        autoInstall: true,
        delayLink: false,
        delayLinkTime: 300,
        deviceIdKey: CUSTOM_TOKEN_KEY,
        beforeGenerateLog: null,
        autoTrackPrefix: 'zhiyun-',
        localGenerateDeviceId: true,
        routeChangeAfter: null
    };
    var scriptDom = document.querySelector('script[track-key]') || document.querySelector('script[trackKey]');
    if (scriptDom) {
        var trackKey = scriptDom.getAttribute('track-key') || scriptDom.getAttribute('trackKey') || '';
        if (trackKey) {
            config.trackKey = trackKey;
        }
        var autoTrackPrefix = scriptDom.getAttribute('auto-track-prefix');
        if (autoTrackPrefix) {
            config.autoTrackPrefix = autoTrackPrefix;
        }
    }
    function getConfig() {
        return config;
    }
    function setConfig(data) {
        config = __assign(__assign({}, config), data);
    }
    function getDeviceId() {
        var config = getConfig();
        var deviceId = getCookie(config.deviceIdKey) ||
            localStorage.getItem(config.deviceIdKey) ||
            (config.localGenerateDeviceId ? getUUID() : null);
        if (deviceId) {
            setCookie(config.deviceIdKey, deviceId);
            localStorage.setItem(config.deviceIdKey, deviceId);
        }
        return deviceId;
    }
    var clientInfo = {
        clientWidth: window.screen.height,
        clientHeight: window.screen.width,
        radio: window.devicePixelRatio || 1,
        domain: document.domain || '',
        appId: 'H5',
        appVersion: null,
        appType: 'H5',
        marketId: null,
        sessionId: getUUID(),
        channel: null,
        deviceId: getDeviceId()
    };
    var setClientInfo = function (info) {
        var urlInfoStr = getQueryVariable('telescope-info');
        var urlInfo = {};
        if (urlInfoStr) {
            try {
                urlInfo = JSON.parse(decodeURIComponent(urlInfoStr));
            }
            catch (error) { }
        }
        var cookieInfoStr = getCookie('TELESCOPE_CACHE_INFO');
        var cookieInfo = {};
        if (cookieInfoStr) {
            try {
                cookieInfo = JSON.parse(cookieInfoStr);
            }
            catch (error) { }
        }
        if (cookieInfo.expired && cookieInfo.expired < Date.now()) {
            cookieInfo.channel = null;
            cookieInfo.sessionId = getUUID();
        }
        delete cookieInfo.expired;
        var channel = getQueryVariable('channel') || urlInfo.channel || cookieInfo.channel;
        clientInfo = __assign(__assign(__assign(__assign(__assign({}, clientInfo), cookieInfo), urlInfo), { channel: channel }), info);
        if (/_mini_/.test(clientInfo.appId)) {
            clientInfo.appType = 'MINI';
        }
        if (clientInfo.deviceId) {
            var config_1 = getConfig();
            setCookie(config_1.deviceIdKey, clientInfo.deviceId);
            localStorage.setItem(config_1.deviceIdKey, clientInfo.deviceId);
        }
        else {
            clientInfo.deviceId = getDeviceId();
        }
        setCookie('TELESCOPE_CACHE_INFO', JSON.stringify({
            appId: clientInfo.appId,
            appVersion: clientInfo.appVersion,
            marketId: clientInfo.marketId,
            channel: clientInfo.channel,
            sessionId: clientInfo.sessionId,
            deviceId: clientInfo.deviceId,
            expired: Date.now() + 30 * 60 * 1000
        }));
    };
    if (inMin) {
        setClientInfo({
            appType: 'MINI'
        });
    }
    else if (inWechat) {
        setClientInfo({
            appId: 'wechat',
            appType: 'WECHAT'
        });
    }
    var getClientInfo = function () {
        setClientInfo({});
        return __assign({}, clientInfo);
    };
    var userInfo = {
        uid: null,
        isLogin: false
    };
    function setUserInfo(info) {
        userInfo = __assign(__assign({}, userInfo), info);
    }
    function getUserInfo() {
        return userInfo;
    }
    function login(info) {
        var newUserInfo = __assign(__assign({}, info), { isLogin: true });
        setUserInfo(newUserInfo);
    }
    function logout() {
        setUserInfo({ uid: null, isLogin: false });
    }
    function http(data, url, cb) {
        if (cb === void 0) { cb = function () { }; }
        var dataStr = data;
        var config = getConfig();
        url = (url || config.serverUrl) + "?" + (config.trackKey ? "trackKey=" + config.trackKey + "&" : '') + "time=" + Date.now();
        if (window.location.protocol === 'https:' &&
            typeof window.navigator.sendBeacon === 'function' &&
            typeof Blob === 'function') {
            var headers = {
                type: 'text/plain; charset=UTF-8'
            };
            var blob = new Blob([dataStr], headers);
            var success = window.navigator.sendBeacon(url, blob);
            if (success) {
                cb();
                return;
            }
        }
        if (dataStr.length > 2000) {
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.addEventListener('readystatechange', function () {
                if (this.readyState === 4) {
                    cb();
                }
            });
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
            xhr.withCredentials = true;
            xhr.send(dataStr);
        }
        else {
            var img = new Image();
            img.onload = function () {
                cb();
            };
            img.src = url + "&data=" + encodeURIComponent(dataStr);
        }
    }
    var libInfo = {
        libVersion: '2.2.2',
        libType: 'js'
    };
    function getNetInfo () {
        var connection = window.navigator.connection ||
            window.navigator.mozConnection ||
            window.navigator.webkitConnection ||
            {};
        if (!connection) {
            return {};
        }
        var type = connection.type || connection.effectiveType;
        if (!type) {
            return {};
        }
        return {
            netType: type
        };
    }
    var DurationTime =  (function () {
        function DurationTime() {
            this.startTime = Date.now();
            this.endTime = Date.now();
            this.config = null;
            this.timeMap = {};
        }
        DurationTime.getInstance = function () {
            if (!DurationTime.instance) {
                DurationTime.instance = new DurationTime();
            }
            return DurationTime.instance;
        };
        DurationTime.prototype.start = function (info) {
            if (!info.trackId || this.timeMap[info.trackId]) {
                return;
            }
            this.timeMap[info.trackId + hashCode(JSON.stringify(info.custom))] = __assign({ startTime: Date.now() }, info);
        };
        DurationTime.prototype.beat = function (key) {
            var logs = [];
            if (key) {
                if (typeof key !== 'string') {
                    key = key.trackId + hashCode(JSON.stringify(key.custom));
                }
                if (this.timeMap[key]) {
                    logs.push({
                        id: this.timeMap[key].id,
                        durationTime: Date.now() - this.timeMap[key].startTime
                    });
                }
                return logs;
            }
            for (var key_1 in this.timeMap) {
                if (!this.timeMap[key_1]) {
                    continue;
                }
                logs.push({
                    id: this.timeMap[key_1].id,
                    durationTime: Date.now() - this.timeMap[key_1].startTime
                });
            }
            return logs;
        };
        DurationTime.prototype.end = function (key) {
            var logs = [];
            if (key) {
                if (typeof key !== 'string') {
                    key = key.trackId + hashCode(JSON.stringify(key.custom));
                }
                if (this.timeMap[key]) {
                    logs.push(this.generateLog(this.timeMap[key]));
                    this.timeMap[key] = null;
                }
                return logs;
            }
            for (var key_2 in this.timeMap) {
                if (!this.timeMap[key_2]) {
                    continue;
                }
                logs.push(this.generateLog(this.timeMap[key_2]));
                this.timeMap[key_2] = null;
            }
            return logs;
        };
        DurationTime.prototype.generateLog = function (info) {
            var log = __assign(__assign({}, info), { actionType: info.actionType === ACTION_TYPE.PAGE ? ACTION_TYPE.DURATION : ACTION_TYPE.VIEW_DURATION, durationTime: Date.now() - info.startTime, trackTime: Date.now(), masterId: info.id, trackId: '', pageId: info.actionType === ACTION_TYPE.PAGE ? info.trackId : info.pageId, id: getUUID() });
            return log;
        };
        DurationTime.instance = null;
        return DurationTime;
    }());
    var instance = DurationTime.getInstance();
    var pick =
    _curry2_1(function pick(names, obj) {
      var result = {};
      var idx = 0;
      while (idx < names.length) {
        if (names[idx] in obj) {
          result[names[idx]] = obj[names[idx]];
        }
        idx += 1;
      }
      return result;
    });
    var pick_1 = pick;
    var businessExtension = {
        seKeywords: getQueryVariable('seKeywords'),
        bizId: getQueryVariable('bizId')
    };
    var getBusinessExtension = function () {
        return __assign({}, businessExtension);
    };
    var setBuinessExtension = function (extension) {
        businessExtension = __assign(__assign({}, businessExtension), extension);
    };
    function sendInfo() {
        var clientInfo = getClientInfo();
        if (clientInfo.appId === 'H5') {
            return;
        }
        var pageInfo = getPageInfo();
        var sourceEventId = null;
        try {
            var sourceEventInfo = JSON.parse(localStorage.getItem('source_event_id'));
            sourceEventId = sourceEventInfo && sourceEventInfo.date + 5000 > Date.now() ? sourceEventInfo.recentId : '';
        }
        catch (error) { }
        var ua = window.navigator.userAgent;
        if (/miniprogram/i.test(ua)) {
            try {
                if (window.wx && window.wx.miniProgram) {
                    window.wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            window.wx.miniProgram.postMessage({
                                data: {
                                    type: 'TELESCOPE_INFO',
                                    data: { referrerId: pageInfo.pageId, sourceEventId: sourceEventId, channel: clientInfo.channel }
                                }
                            });
                        }
                    });
                }
                else {
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.onload = function () {
                        if (window.wx && window.wx.miniProgram) {
                            window.wx.miniProgram.getEnv(function (res) {
                                if (res.miniprogram) {
                                    window.wx.miniProgram.postMessage({
                                        data: {
                                            type: 'TELESCOPE_INFO',
                                            data: { referrerId: pageInfo.pageId, sourceEventId: sourceEventId, channel: clientInfo.channel }
                                        }
                                    });
                                }
                            });
                        }
                    };
                    script.src = '//static.91jkys.com/attachment/20210316204652605_db936fce9cf540e89ae70226ea953f44.js';
                    document.body.appendChild(script);
                }
            }
            catch (error) { }
        }
        if (typeof Sailer !== 'undefined' && /AppInfo|tangyi/.test(ua)) {
            Sailer.nativeCall('sendEventInfo', {
                referrerId: pageInfo.pageId,
                channel: clientInfo.channel,
                sourceEventId: sourceEventId
            });
        }
    }
    var allData = [];
    var allDebugData = [];
    var allDurationData = [];
    var timer = null;
    function send(data) {
        var config = getConfig();
        var sendType = config.sendType;
        if (data.actionType === 'PAGE' ||
            data.actionType === 'VIEW' ||
            data.actionType === 'DURATION' ||
            data.actionType === 'VIEW_DURATION') {
            sendDurationLog(data);
            return;
        }
        if (sendType === SEND_TYPE.SYNC) {
            sendSync(data);
        }
        else if (sendType === SEND_TYPE.ASYNC) {
            sendAsync(data);
        }
    }
    function sendDurationLog(data) {
        var config = getConfig();
        if (data) {
            var newData = _generateData(data, config)[0];
            if (!newData) {
                return;
            }
            allDurationData.push(newData);
        }
        if (config.sendType === SEND_TYPE.SYNC || data.actionType === 'DURATION' || data.actionType === 'VIEW_DURATION') {
            sendSync();
        }
        else if (config.sendType === SEND_TYPE.ASYNC) {
            sendAsync();
        }
    }
    function sendQuick(data) {
        sendSync();
        var config = getConfig();
        sendToServer(data, config.durationServerUrl);
    }
    function sendBeat(data) {
        sendSync();
        var config = getConfig();
        return http(JSON.stringify(data), config.beatServerUrl);
    }
    function sendSync(data) {
        var config = getConfig();
        if (data) {
            var _a = _generateData(data, config), newData = _a[0], debug = _a[1];
            if (!newData) {
                return;
            }
            if (debug) {
                allDebugData.push(newData);
            }
            else {
                allData.push(newData);
            }
        }
        clearTimeout(timer);
        sendToServer(allDurationData, config.durationServerUrl);
        sendToServer(allData);
        sendToServer(allDebugData, config.debugServerUrl);
        allDurationData.length = 0;
        allData.length = 0;
        allDebugData.length = 0;
    }
    function sendAsync(data) {
        var config = getConfig();
        if (data) {
            var _a = _generateData(data, config), newData = _a[0], debug = _a[1];
            if (!newData) {
                return;
            }
            if (debug) {
                allDebugData.push(newData);
            }
            else {
                allData.push(newData);
            }
        }
        clearTimeout(timer);
        if ((!data && allData.length > 0) || allData.length >= 10 || allDebugData.length >= 10) {
            sendSync();
            return;
        }
        timer = setTimeout(function () {
            sendSync();
        }, config.delayTime);
    }
    function sendToServer(data, url) {
        if (!data || !data.length) {
            return;
        }
        return http(JSON.stringify(_wrapperData(data)), url);
    }
    function _wrapperData(data) {
        var config = getConfig();
        var wrapperData = __assign(__assign(__assign(__assign({ customTime: Date.now(), items: data }, getClientInfo()), libInfo), getUserInfo()), { version: config.version });
        return wrapperData;
    }
    function _generateData(data, config) {
        if (typeof config.beforeGenerateLog === 'function') {
            data = config.beforeGenerateLog(data);
            if (!data) {
                return [null, !!data.debug];
            }
        }
        if (isObject(data.custom)) {
            data.custom = JSON.stringify(data.custom);
        }
        if (typeof data.custom === 'string' && data.custom.length > 800) {
            data.custom = data.custom.substr(0, 800) + '[超出800部分被裁剪]';
        }
        var newData = pick_1(SAFETY_KEY, data);
        var pageInfo = getPageInfo();
        var netInfo = getNetInfo();
        setBuinessExtension({
            seKeywords: getQueryVariable('seKeywords'),
            bizId: getQueryVariable('bizId')
        });
        var businessInfo = getBusinessExtension();
        if (data.actionType === ACTION_TYPE.PAGE) {
            setPageInfo({
                pageId: data.trackId || ''
            });
            setReferrerId('BEAT');
            pageInfo = getPageInfo();
            pageInfo.pageId = null;
        }
        if (data.actionType === ACTION_TYPE.EVENT) {
            setSourceEventId('RECORD', data);
            pageInfo = getPageInfo();
        }
        var uuid = getUUID();
        var result = __assign(__assign(__assign(__assign(__assign({}, newData), pageInfo), netInfo), businessInfo), { trackTime: Date.now(), id: uuid });
        if (!data.debug) {
            window._TELESCOPE_LOG_ID = uuid;
            if (result.actionType === ACTION_TYPE.PAGE) {
                var durationLogs = instance.end();
                if (durationLogs && durationLogs.length) {
                    sendQuick(durationLogs);
                }
                instance.start(result);
            }
            if (result.actionType === ACTION_TYPE.VIEW) {
                instance.start(result);
            }
            sendInfo();
        }
        return [result, !!data.debug];
    }
    var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};
    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }
    var vissense = createCommonjsModule(function (module, exports) {
    !function(root, name, factory) {
        var withWindow = function(win) {
            var product = factory(win, win.document);
            return product.noConflict = function() {
                return product;
            }, product;
        };
        module.exports = function(win) {
            return withWindow(win);
        };
    }(commonjsGlobal$1, "VisSense", function(window, document, undefined$1) {
        function async(callback, delay) {
            return function() {
                var args = arguments;
                return defer(function() {
                    callback.apply(undefined$1, args);
                }, delay || 0);
            };
        }
        function debounce(callback, delay) {
            var cancel = noop;
            return function() {
                var self = this, args = arguments;
                cancel(), cancel = defer(function() {
                    callback.apply(self, args);
                }, delay);
            };
        }
        function defaults(dest, source) {
            var sourceIsObject = isObject(source), destIsObject = isObject(dest);
            return sourceIsObject || destIsObject ? sourceIsObject && destIsObject ? (forEach(Object.keys(source), function(property) {
                dest[property] === undefined$1 && (dest[property] = source[property]);
            }), dest) : sourceIsObject ? source : dest : source;
        }
        function defer(callback, delay) {
            var timer = setTimeout(function() {
                callback();
            }, delay || 0);
            return function() {
                clearTimeout(timer);
            };
        }
        function fireIf(when, callback) {
            return function() {
                return (isFunction(when) ? when() : when) ? callback() : undefined$1;
            };
        }
        function extend(dest, source, callback) {
            for (var index = -1, props = Object.keys(source), length = props.length, ask = isFunction(callback); ++index < length; ) {
                var key = props[index];
                dest[key] = ask ? callback(dest[key], source[key], key, dest, source) : source[key];
            }
            return dest;
        }
        function forEach(array, callback, thisArg) {
            for (var i = 0, n = array.length; n > i; i++) {
                var result = callback.call(thisArg, array[i], i, array);
                if (result !== undefined$1) return result;
            }
        }
        function identity(value) {
            return value;
        }
        function isDefined(value) {
            return value !== undefined$1;
        }
        function isArray(value) {
            return value && "object" == typeof value && "number" == typeof value.length && "[object Array]" === Object.prototype.toString.call(value) || !1;
        }
        function isElement(value) {
            return value && 1 === value.nodeType || !1;
        }
        function isFunction(value) {
            return "function" == typeof value || !1;
        }
        function isObject(value) {
            var type = typeof value;
            return "function" === type || value && "object" === type || !1;
        }
        function noop() {}
        function now() {
            return new Date().getTime();
        }
        function once(callback) {
            var cache, called = !1;
            return function() {
                return called || (cache = callback.apply(undefined$1, arguments), called = !0), cache;
            };
        }
        function throttle(callback, wait, thisArg) {
            var cancel = noop, last = !1;
            return function() {
                var time = now(), args = arguments, func = function() {
                    last = time, callback.apply(thisArg, args);
                };
                last && last + wait > time ? (cancel(), cancel = defer(func, wait)) : (last = time,
                defer(func, 0));
            };
        }
        function viewport(referenceWindow) {
            var win = referenceWindow || window;
            return {
                height: win.innerHeight,
                width: win.innerWidth
            };
        }
        function computedStyle(element, referenceWindow) {
            return (referenceWindow || window).getComputedStyle(element, null);
        }
        function styleProperty(style, property) {
            return style.getPropertyValue(property);
        }
        function isDisplayed(element, style) {
            style || (style = computedStyle(element));
            var display = styleProperty(style, "display");
            if ("none" === display) return !1;
            var parent = element.parentNode;
            return isElement(parent) ? isDisplayed(parent) : !0;
        }
        function isVisibleByStyling(element, referenceWindow) {
            if (element === (referenceWindow || window).document) return !0;
            if (!element || !element.parentNode) return !1;
            var style = computedStyle(element, referenceWindow), visibility = styleProperty(style, "visibility");
            return "hidden" === visibility || "collapse" === visibility ? !1 : isDisplayed(element, style);
        }
        function isInViewport(rect, viewport) {
            return !rect || rect.width <= 0 || rect.height <= 0 ? !1 : rect.bottom > 0 && rect.right > 0 && rect.top < viewport.height && rect.left < viewport.width;
        }
        function percentage(element, referenceWindow) {
            var rect = element.getBoundingClientRect(), view = viewport(referenceWindow);
            if (!isInViewport(rect, view) || !isVisibleByStyling(element)) return 0;
            var vh = 0, vw = 0;
            return rect.top >= 0 ? vh = Math.min(rect.height, view.height - rect.top) : rect.bottom > 0 && (vh = Math.min(view.height, rect.bottom)),
            rect.left >= 0 ? vw = Math.min(rect.width, view.width - rect.left) : rect.right > 0 && (vw = Math.min(view.width, rect.right)),
            vh * vw / (rect.height * rect.width);
        }
        function isPageVisible(referenceWindow) {
            return !createVisibilityApi(referenceWindow || window).isHidden();
        }
        function VisSense(element, config) {
            if (!(this instanceof VisSense)) return new VisSense(element, config);
            if (!isElement(element)) throw new Error("not an element node");
            this._element = element, this._config = defaults(config, {
                fullyvisible: 1,
                hidden: 0,
                referenceWindow: window,
                percentageHook: percentage,
                precision: 3,
                visibilityHooks: []
            });
            var roundFactor = this._config.precision <= 0 ? 1 : Math.pow(10, this._config.precision || 3);
            this._round = function(val) {
                return Math.round(val * roundFactor) / roundFactor;
            };
            var visibilityApi = createVisibilityApi(this._config.referenceWindow);
            this._config.visibilityHooks.push(function() {
                return !visibilityApi.isHidden();
            });
        }
        function nextState(visobj, currentState) {
            var newState = visobj.state(), percentage = newState.percentage;
            return currentState && percentage === currentState.percentage && currentState.percentage === currentState.previous.percentage ? currentState : newState.hidden ? VisSense.VisState.hidden(percentage, currentState) : newState.fullyvisible ? VisSense.VisState.fullyvisible(percentage, currentState) : VisSense.VisState.visible(percentage, currentState);
        }
        function VisMon(visobj, config) {
            var _config = defaults(config, {
                strategy: [ new VisMon.Strategy.PollingStrategy(), new VisMon.Strategy.EventStrategy() ],
                async: !1
            });
            this._visobj = visobj, this._state = {}, this._started = !1;
            var anyTopicName = "*#" + now();
            this._pubsub = new PubSub({
                async: _config.async,
                anyTopicName: anyTopicName
            }), this._events = [ anyTopicName, "start", "stop", "update", "hidden", "visible", "fullyvisible", "percentagechange", "visibilitychange" ],
            this._strategy = new VisMon.Strategy.CompositeStrategy(_config.strategy), this._strategy.init(this),
            this._pubsub.on("update", function(monitor) {
                var newValue = monitor._state.percentage, oldValue = monitor._state.previous.percentage;
                newValue !== oldValue && monitor._pubsub.publish("percentagechange", [ monitor, newValue, oldValue ]);
            }), this._pubsub.on("update", function(monitor) {
                monitor._state.code !== monitor._state.previous.code && monitor._pubsub.publish("visibilitychange", [ monitor ]);
            }), this._pubsub.on("visibilitychange", function(monitor) {
                monitor._state.visible && !monitor._state.previous.visible && monitor._pubsub.publish("visible", [ monitor ]);
            }), this._pubsub.on("visibilitychange", function(monitor) {
                monitor._state.fullyvisible && monitor._pubsub.publish("fullyvisible", [ monitor ]);
            }), this._pubsub.on("visibilitychange", function(monitor) {
                monitor._state.hidden && monitor._pubsub.publish("hidden", [ monitor ]);
            }), forEach(this._events, function(event) {
                isFunction(_config[event]) && this.on(event, _config[event]);
            }, this);
        }
        var createVisibilityApi = function(referenceWindow) {
            return function(document, undefined$1) {
                var entry = function(propertyName, eventName) {
                    return {
                        property: propertyName,
                        event: eventName
                    };
                }, event = "visibilitychange", dict = [ entry("webkitHidden", "webkit" + event), entry("msHidden", "ms" + event), entry("mozHidden", "moz" + event), entry("hidden", event) ], api = forEach(dict, function(entry) {
                    return document[entry.property] !== undefined$1 ? {
                        isHidden: function() {
                            return !!document[entry.property] || !1;
                        },
                        onVisibilityChange: function(callback) {
                            return document.addEventListener(entry.event, callback, !1), function() {
                                document.removeEventListener(entry.event, callback, !1);
                            };
                        }
                    } : void 0;
                });
                return api || {
                    isHidden: function() {
                        return !1;
                    },
                    onVisibilityChange: function() {
                        return noop;
                    }
                };
            }((referenceWindow || window).document);
        }, PubSub = function(undefined$1) {
            function PubSub(config) {
                this._cache = {}, this._onAnyCache = [], this._config = defaults(config, {
                    async: !1,
                    anyTopicName: "*"
                });
            }
            var syncFireListeners = function(consumers, args) {
                forEach(consumers, function(consumer) {
                    consumer(args);
                });
            };
            return PubSub.prototype.on = function(topic, callback) {
                if (!isFunction(callback)) return noop;
                var applyCallback = function(args) {
                    return callback.apply(undefined$1, args || []);
                }, listener = this._config.async ? async(applyCallback) : applyCallback, unregister = function(listener, array, topic) {
                    return function() {
                        var index = array.indexOf(listener);
                        return index > -1 ? (array.splice(index, 1), !0) : !1;
                    };
                };
                return topic === this._config.anyTopicName ? (this._onAnyCache.push(listener), unregister(listener, this._onAnyCache)) : (this._cache[topic] || (this._cache[topic] = []),
                this._cache[topic].push(listener), unregister(listener, this._cache[topic]));
            }, PubSub.prototype.publish = function(topic, args) {
                var listeners = (this._cache[topic] || []).concat(topic === this._config.anyTopicName ? [] : this._onAnyCache), enableAsync = !!this._config.async, syncOrAsyncPublish = enableAsync ? async(syncFireListeners) : function(listeners, args) {
                    return syncFireListeners(listeners, args), noop;
                };
                return syncOrAsyncPublish(listeners, args || []);
            }, PubSub;
        }();
        VisSense.prototype.state = function() {
            var hiddenByHook = forEach(this._config.visibilityHooks, function(hook) {
                return hook(this._element) ? void 0 : VisSense.VisState.hidden(0);
            }, this);
            return hiddenByHook || function(visobj, element, config) {
                var perc = visobj._round(config.percentageHook(element, config.referenceWindow));
                return perc <= config.hidden ? VisSense.VisState.hidden(perc) : perc >= config.fullyvisible ? VisSense.VisState.fullyvisible(perc) : VisSense.VisState.visible(perc);
            }(this, this._element, this._config);
        }, VisSense.prototype.percentage = function() {
            return this.state().percentage;
        }, VisSense.prototype.element = function() {
            return this._element;
        }, VisSense.prototype.referenceWindow = function() {
            return this._config.referenceWindow;
        }, VisSense.prototype.isFullyVisible = function() {
            return this.state().fullyvisible;
        }, VisSense.prototype.isVisible = function() {
            return this.state().visible;
        }, VisSense.prototype.isHidden = function() {
            return this.state().hidden;
        }, VisSense.fn = VisSense.prototype, VisSense.of = function(element, config) {
            return new VisSense(element, config);
        };
        var STATES = {
            HIDDEN: [ 0, "hidden" ],
            VISIBLE: [ 1, "visible" ],
            FULLY_VISIBLE: [ 2, "fullyvisible" ]
        };
        return VisSense.VisState = function() {
            function newVisState(state, percentage, previous) {
                return previous && delete previous.previous, {
                    code: state[0],
                    state: state[1],
                    percentage: percentage,
                    previous: previous || {},
                    fullyvisible: state[0] === STATES.FULLY_VISIBLE[0],
                    visible: state[0] === STATES.VISIBLE[0] || state[0] === STATES.FULLY_VISIBLE[0],
                    hidden: state[0] === STATES.HIDDEN[0]
                };
            }
            return {
                hidden: function(percentage, previous) {
                    return newVisState(STATES.HIDDEN, percentage, previous);
                },
                visible: function(percentage, previous) {
                    return newVisState(STATES.VISIBLE, percentage, previous);
                },
                fullyvisible: function(percentage, previous) {
                    return newVisState(STATES.FULLY_VISIBLE, percentage, previous);
                }
            };
        }(), VisMon.prototype.visobj = function() {
            return this._visobj;
        }, VisMon.prototype.publish = function(eventName, args) {
            var isInternalEvent = this._events.indexOf(eventName) >= 0;
            if (isInternalEvent) throw new Error('Cannot publish internal event "' + eventName + '" from external scope.');
            return this._pubsub.publish(eventName, args);
        }, VisMon.prototype.state = function() {
            return this._state;
        }, VisMon.prototype.start = function(config) {
            if (this._started) return this;
            var _config = defaults(config, {
                async: !1
            });
            return this._cancelAsyncStart && this._cancelAsyncStart(), _config.async ? this.startAsync() : (this._started = !0,
            this.update(), this._pubsub.publish("start", [ this ]), this._strategy.start(this),
            this);
        }, VisMon.prototype.startAsync = function(config) {
            this._cancelAsyncStart && this._cancelAsyncStart();
            var me = this, cancelAsyncStart = defer(function() {
                me.start(extend(defaults(config, {}), {
                    async: !1
                }));
            });
            return this._cancelAsyncStart = function() {
                cancelAsyncStart(), me._cancelAsyncStart = null;
            }, this;
        }, VisMon.prototype.stop = function() {
            this._cancelAsyncStart && this._cancelAsyncStart(), this._started && (this._strategy.stop(this),
            this._pubsub.publish("stop", [ this ])), this._started = !1;
        }, VisMon.prototype.update = function() {
            this._started && (this._state = nextState(this._visobj, this._state), this._pubsub.publish("update", [ this ]));
        }, VisMon.prototype.on = function(topic, callback) {
            return this._pubsub.on(topic, callback);
        }, VisMon.Builder = function() {
            var combineStrategies = function(config, strategies) {
                var combinedStrategies = null, forceDisableStrategies = config.strategy === !1, enableStrategies = !forceDisableStrategies && (config.strategy || strategies.length > 0);
                if (enableStrategies) {
                    var configStrategyIsDefined = !!config.strategy, configStrategyIsArray = isArray(config.strategy), configStrategyAsArray = configStrategyIsDefined ? configStrategyIsArray ? config.strategy : [ config.strategy ] : [];
                    combinedStrategies = configStrategyAsArray.concat(strategies);
                } else combinedStrategies = forceDisableStrategies ? [] : config.strategy;
                return combinedStrategies;
            };
            return function(visobj) {
                var config = {}, strategies = [], events = [], productBuilt = !1, product = null;
                return {
                    set: function(name, value) {
                        return config[name] = value, this;
                    },
                    strategy: function(strategy) {
                        return strategies.push(strategy), this;
                    },
                    on: function(event, handler) {
                        return events.push([ event, handler ]), this;
                    },
                    build: function(consumer) {
                        var manufacture = function() {
                            var combinedStrategies = combineStrategies(config, strategies);
                            config.strategy = combinedStrategies;
                            var monitor = visobj.monitor(config);
                            return forEach(events, function(event) {
                                monitor.on(event[0], event[1]);
                            }), productBuilt = !0, product = monitor;
                        }, monitor = productBuilt ? product : manufacture();
                        return isFunction(consumer) ? consumer(monitor) : monitor;
                    }
                };
            };
        }(), VisMon.Strategy = function() {}, VisMon.Strategy.prototype.init = noop, VisMon.Strategy.prototype.start = noop,
        VisMon.Strategy.prototype.stop = noop, VisMon.Strategy.CompositeStrategy = function(strategies) {
            this._strategies = isArray(strategies) ? strategies : [ strategies ];
        }, VisMon.Strategy.CompositeStrategy.prototype = Object.create(VisMon.Strategy.prototype),
        VisMon.Strategy.CompositeStrategy.prototype.init = function(monitor) {
            forEach(this._strategies, function(strategy) {
                isFunction(strategy.init) && strategy.init(monitor);
            });
        }, VisMon.Strategy.CompositeStrategy.prototype.start = function(monitor) {
            forEach(this._strategies, function(strategy) {
                isFunction(strategy.start) && strategy.start(monitor);
            });
        }, VisMon.Strategy.CompositeStrategy.prototype.stop = function(monitor) {
            forEach(this._strategies, function(strategy) {
                isFunction(strategy.stop) && strategy.stop(monitor);
            });
        }, VisMon.Strategy.PollingStrategy = function(config) {
            this._config = defaults(config, {
                interval: 1e3
            }), this._started = !1;
        }, VisMon.Strategy.PollingStrategy.prototype = Object.create(VisMon.Strategy.prototype),
        VisMon.Strategy.PollingStrategy.prototype.start = function(monitor) {
            return this._started || (this._clearInterval = function(interval) {
                var intervalId = setInterval(function() {
                    monitor.update();
                }, interval);
                return function() {
                    clearInterval(intervalId);
                };
            }(this._config.interval), this._started = !0), this._started;
        }, VisMon.Strategy.PollingStrategy.prototype.stop = function() {
            return this._started ? (this._clearInterval(), this._started = !1, !0) : !1;
        }, VisMon.Strategy.EventStrategy = function(config) {
            this._config = defaults(config, {
                throttle: 50
            }), this._config.debounce > 0 && (this._config.throttle = +this._config.debounce),
            this._started = !1;
        }, VisMon.Strategy.EventStrategy.prototype = Object.create(VisMon.Strategy.prototype),
        VisMon.Strategy.EventStrategy.prototype.start = function(monitor) {
            return this._started || (this._removeEventListeners = function(update) {
                var referenceWindow = monitor.visobj().referenceWindow(), visibilityApi = createVisibilityApi(referenceWindow), removeOnVisibilityChangeEvent = visibilityApi.onVisibilityChange(update);
                return referenceWindow.addEventListener("scroll", update, !1), referenceWindow.addEventListener("resize", update, !1),
                referenceWindow.addEventListener("touchmove", update, !1), function() {
                    referenceWindow.removeEventListener("touchmove", update, !1), referenceWindow.removeEventListener("resize", update, !1),
                    referenceWindow.removeEventListener("scroll", update, !1), removeOnVisibilityChangeEvent();
                };
            }(throttle(function() {
                monitor.update();
            }, this._config.throttle)), this._started = !0), this._started;
        }, VisMon.Strategy.EventStrategy.prototype.stop = function() {
            return this._started ? (this._removeEventListeners(), this._started = !1, !0) : !1;
        }, VisSense.VisMon = VisMon, VisSense.PubSub = PubSub, VisSense.fn.monitor = function(config) {
            return new VisMon(this, config);
        }, VisSense.Utils = {
            async: async,
            debounce: debounce,
            defaults: defaults,
            defer: defer,
            extend: extend,
            forEach: forEach,
            fireIf: fireIf,
            identity: identity,
            isArray: isArray,
            isDefined: isDefined,
            isElement: isElement,
            isFunction: isFunction,
            isObject: isObject,
            isPageVisible: isPageVisible,
            isVisibleByStyling: isVisibleByStyling,
            noop: noop,
            now: now,
            once: once,
            throttle: throttle,
            percentage: percentage,
            VisibilityApi: createVisibilityApi(),
            createVisibilityApi: createVisibilityApi,
            _viewport: viewport,
            _isInViewport: isInViewport,
            _isDisplayed: isDisplayed,
            _computedStyle: computedStyle,
            _styleProperty: styleProperty
        }, VisSense;
    });
    });
    var VisSense = vissense(window);
    var VisSenseUtils = VisSense.Utils;
    var createInnerMonitor = function (outerMonitor, callback, config) {
        var timeElapsed = 0;
        var timeStarted = null;
        var timeLimit = config.timeLimit;
        var percentageLimit = config.percentageLimit;
        var interval = config.interval;
        return VisSense.VisMon.Builder(outerMonitor.visobj())
            .strategy(new VisSense.VisMon.Strategy.PollingStrategy({ interval: interval }))
            .on('update', function (monitor) {
            var percentage = monitor.state().percentage;
            if (percentage < percentageLimit) {
                timeStarted = null;
            }
            else {
                var now = VisSenseUtils.now();
                timeStarted = timeStarted || now;
                timeElapsed = now - timeStarted;
            }
            if (timeElapsed >= timeLimit) {
                monitor.stop();
                outerMonitor.stop();
                callback(monitor);
            }
        })
            .on('stop', function () {
            timeStarted = null;
        })
            .build();
    };
    var onPercentageTimeTestPassed = function (visobj, callback, config) {
        var _config = VisSenseUtils.defaults(config, {
            percentageLimit: 1,
            timeLimit: 1000,
            interval: 100,
            strategy: undefined
        });
        var hiddenLimit = Math.max(_config.percentageLimit - 0.001, 0);
        var innerMonitor = null;
        var outerMonitor = VisSense.VisMon.Builder(new VisSense(visobj.element(), {
            hidden: hiddenLimit,
            referenceWindow: visobj.referenceWindow()
        }))
            .set('strategy', _config.strategy)
            .on('visible', function (monitor) {
            if (innerMonitor === null) {
                innerMonitor = createInnerMonitor(monitor, callback, _config);
            }
            innerMonitor.start();
        })
            .on('hidden', function () {
            if (innerMonitor !== null) {
                innerMonitor.stop();
            }
        })
            .on('stop', function () {
            if (innerMonitor !== null) {
                innerMonitor.stop();
            }
        })
            .build();
        outerMonitor.start();
        return function () {
            outerMonitor.stop();
            innerMonitor = null;
        };
    };
    VisSense.fn.onPercentageTimeTestPassed = function (callback, config) {
        onPercentageTimeTestPassed(this, callback, config);
    };
    var ActionTracker =  (function () {
        function ActionTracker() {
            this.record = {
                pageId: '',
                pageTrackTime: null,
                eventId: '',
                eventTrackTime: null
            };
            this.trackEvent = this.trackEvent.bind(this);
            this.trackPage = this.trackPage.bind(this);
            this.trackViewStart = this.trackViewStart.bind(this);
            this.trackView = this.trackView.bind(this);
            this.trackViewEnd = this.trackViewEnd.bind(this);
            this.trackLog = this.trackLog.bind(this);
        }
        ActionTracker.getInstance = function () {
            if (!ActionTracker.instance) {
                ActionTracker.instance = new ActionTracker();
            }
            return ActionTracker.instance;
        };
        ActionTracker.prototype.trackPage = function (info) {
            var _this = this;
            if (info === void 0) { info = {}; }
            setTimeout(function () {
                var _a = getConfig(), offlineUrl = _a.offlineUrl, autoTrackPrefix = _a.autoTrackPrefix;
                var data = __assign({ actionType: ACTION_TYPE.PAGE }, info);
                if (!data.trackId) {
                    data.trackId = autoTrackPrefix + "page-" + hashCode(getRealPath(window.location.href, offlineUrl));
                    data.isAutoTrack = true;
                    _this.record.pageId = null;
                }
                else {
                    _this.record.pageTrackTime = Date.now();
                    _this.record.pageId = data.trackId;
                    data.autoTrackId = autoTrackPrefix + "page-" + hashCode(getRealPath(window.location.href, offlineUrl));
                }
                data.pageId = data.trackId;
                send(data);
            }, 0);
        };
        ActionTracker.prototype.trackEvent = function (info) {
            if (info === void 0) { info = {}; }
            this._trackEvent(info);
        };
        ActionTracker.prototype._trackEvent = function (info, domInfo) {
            if (info === void 0) { info = {}; }
            var _a = getConfig(), offlineUrl = _a.offlineUrl, autoTrackPrefix = _a.autoTrackPrefix;
            var data = __assign({ actionType: ACTION_TYPE.EVENT, eventName: 'CLICK' }, info);
            if (!data.trackId && !data.debug && domInfo) {
                var code = domInfo.domId ? hashCode(domInfo.domId) : hashCode(domInfo.domPath + domInfo.domTag);
                data.trackId = autoTrackPrefix + "event-" + hashCode(getRealPath(window.location.href, offlineUrl)) + "-" + code;
                data.isAutoTrack = true;
            }
            send(data);
        };
        ActionTracker.prototype.trackView = function (dom, info, visSenseConfig) {
            if (visSenseConfig === void 0) { visSenseConfig = {}; }
            if (dom) {
                var data_1 = __assign({ actionType: ACTION_TYPE.VIEW, domId: dom.id, domClass: dom.className, domTag: dom.tagName, domContent: dom.textContent.substr(0, 20).trim(), domPath: getDomPath(dom) }, info);
                var visobj = VisSense(dom);
                visobj.onPercentageTimeTestPassed(function () {
                    send(data_1);
                }, {
                    percentageLimit: visSenseConfig.percentageLimit || 1,
                    timeLimit: visSenseConfig.timeLimit || 0,
                    interval: 200
                });
            }
        };
        ActionTracker.prototype.trackViewStart = function (info) {
            send(__assign(__assign({}, info), { actionType: ACTION_TYPE.VIEW }));
        };
        ActionTracker.prototype.trackViewEnd = function (info) {
            var logs = instance.end(info);
            sendQuick(logs);
        };
        ActionTracker.prototype.track = function (info) {
            switch (info.actionType) {
                case ACTION_TYPE.EVENT:
                    this.trackEvent(info);
                    break;
                case ACTION_TYPE.PAGE:
                    this.trackPage(info);
                    break;
            }
            send(info);
        };
        ActionTracker.prototype.trackLink = function (linkDom, info) {
            if (info === void 0) { info = {}; }
            var config = getConfig();
            var url = linkDom.getAttribute('href');
            if (config.delayLink && url && /\//.test(url)) {
                setTimeout(function () {
                    if (linkDom.getAttribute('target') === '_blank') {
                        window.open(url);
                    }
                    else {
                        window.location.href = url;
                    }
                }, config.delayLinkTime);
            }
            this.trackDom(linkDom, info);
            sendAsync();
        };
        ActionTracker.prototype.trackDom = function (dom, info) {
            if (info === void 0) { info = {}; }
            var _dom = dom;
            if (_dom.IS_TRACKED) {
                clearTimeout(_dom.DELAY_TRACK_TIME);
                _dom.DELAY_TRACK_TIME = setTimeout(function () {
                    _dom.IS_TRACKED = false;
                }, 1000);
                return;
            }
            _dom.IS_TRACKED = true;
            _dom.DELAY_TRACK_TIME = setTimeout(function () {
                _dom.IS_TRACKED = false;
            }, 1000);
            var domPath = getDomPath(dom);
            var trackInfo = {
                trackId: '',
                domPath: domPath,
                domContent: dom.textContent.substr(0, 20).trim(),
                domHref: dom.href || dom.src || null
            };
            var domInfo = {
                domId: dom.id,
                domClass: dom.className,
                domHref: dom.href || dom.src || '',
                domName: dom.name || '',
                domTag: dom.tagName,
                domPath: domPath,
                domContent: dom.textContent.substr(0, 20).trim()
            };
            var track = dom.getAttribute('data-track');
            if (track && track.search(/^\{[\S\s]*\}$/) >= 0) {
                trackInfo = __assign(__assign({}, trackInfo), JSON.parse(track));
            }
            else {
                trackInfo.trackId = track || '';
            }
            if (info) {
                trackInfo = __assign(__assign({}, trackInfo), info);
            }
            this._trackEvent(trackInfo, domInfo);
        };
        ActionTracker.prototype.trackLog = function (info) {
            if (info === void 0) { info = {}; }
            var data = __assign({ actionType: ACTION_TYPE.EVENT, eventName: 'CLICK', debug: true }, info);
            send(data);
        };
        ActionTracker.instance = null;
        return ActionTracker;
    }());
    var instance$1 = ActionTracker.getInstance();
    function hijackHistoryEvent () {
        if (getFlag('historyInjected'))
            return;
        function historyEventTrigger(event, data) {
            var fetchEvent = new CustomEvent(event, { detail: data });
            window.dispatchEvent(fetchEvent);
        }
        function spellUrl(oldURL, newURL) {
            if (/:\/\//.test(newURL)) {
                return newURL;
            }
            var host = oldURL.match(/^.*:\/\/[^/]+/)[0];
            return host + (/^\//.test(newURL) ? '' : '/') + newURL;
        }
        var globalData = {
            url: getLocationHref()
        };
        var oldOnpopstate = window.onpopstate;
        window.onpopstate = function () {
            var data = {
                newURL: window.location.href,
                oldURL: globalData.url
            };
            globalData.url = window.location.href;
            historyEventTrigger.apply(this, ['historyPopstate', data]);
            if (oldOnpopstate) {
                return oldOnpopstate.apply(this, arguments);
            }
        };
        var oldPushState = window.history.pushState;
        oldPushState &&
            (window.history.pushState = function (state, title, url) {
                var data = {
                    newURL: spellUrl(globalData.url, url),
                    oldURL: globalData.url
                };
                globalData = {
                    url: data.newURL
                };
                historyEventTrigger.apply(this, ['historyPushState', data]);
                if (oldPushState) {
                    return oldPushState.apply(this, arguments);
                }
            });
        setFlag('historyInjected', true);
    }
    function injectedXHR () {
        if (getFlag('XHRInjected'))
            return;
        var oldOpen = XMLHttpRequest.prototype.open;
        var oldSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.open = function () {
            this.url = arguments[1];
            oldOpen.apply(this, arguments);
        };
        XMLHttpRequest.prototype.send = function () {
            var logId = window._TELESCOPE_LOG_ID;
            if (/^https?:\/\/[^.]*\.?apigw\.qa\.(91jkys|dia-solution)\.com/.test(this.url) && logId) {
                this.setRequestHeader('Frontend-Log-Id', logId);
            }
            oldSend.apply(this, arguments);
        };
        XMLHttpRequest.prototype.oldOpen = oldOpen;
        XMLHttpRequest.prototype.oldSend = oldSend;
        setFlag('XHRInjected', true);
    }
    setClientInfo({});
    var install = function (conf) {
        if (getFlag('install'))
            return;
        setFlag('install');
        if (conf) {
            setConfig(conf);
        }
        var config = getConfig();
        if (!config.version && window.version && typeof window.version === 'string') {
            setConfig({ version: window.version });
        }
        setClientInfo({});
        injectedXHR();
        hijackHistoryEvent();
        routeChange();
        var timer = null;
        var timer2 = null;
        function routeChange() {
            clearTimeout(timer);
            clearTimeout(timer2);
            if (config.autoTrackPage) {
                timer = setTimeout(function () {
                    var pageInfo = getPageInfo();
                    if (!pageInfo.pageId && Date.now() - instance$1.record.pageTrackTime > 1000) {
                        instance$1.trackPage();
                    }
                }, 500);
            }
            timer2 = setTimeout(function () {
                if (Date.now() - instance$1.record.pageTrackTime > 1000) {
                    setPageInfo({ pageId: '' });
                }
            }, 100);
            if (config.routeChangeAfter) {
                config.routeChangeAfter();
            }
            setReferrerId('UPDATE');
            setSourceEventId('UPDATE');
            sendInfo();
        }
        if (typeof window.onpopstate === 'undefined') {
            window.addEventListener('hashchange', routeChange);
        }
        window.addEventListener('historyPushState', routeChange);
        window.addEventListener('historyPopstate', routeChange);
        window.addEventListener('visibilitychange', function () {
            var isHidden = document.hidden;
            var pageInfo = getPageInfo();
            if (isHidden) {
                var logs = instance.end();
                sendQuick(logs);
            }
            else {
                instance$1.trackPage({ trackId: pageInfo.pageId });
            }
        });
        var onLeave = (function () {
            var sended = false;
            return function () {
                if (sended) {
                    return;
                }
                var logs = instance.end();
                sendQuick(logs);
                sended = true;
            };
        })();
        var beatFn = function () {
            setReferrerId('BEAT');
            var logs = instance.beat();
            sendBeat(logs);
            setTimeout(beatFn, 3000);
        };
        setTimeout(beatFn, 3000);
        window.addEventListener('beforeunload', onLeave);
        window.addEventListener('unload', onLeave);
        document.addEventListener('click', function (e) {
            var element = e.target;
            var pageId = getPageInfo().pageId;
            var hasTrack = false;
            while (element && element.tagName && element.tagName.toUpperCase() !== 'HTML' && element.getAttribute) {
                var href = element.getAttribute('href');
                if (href && element.tagName === 'A' && /\//.test(href) && config.delayLink) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    else {
                        window.event.returnValue = true;
                    }
                }
                if (element.getAttribute('data-track') ||
                    (config.autoTrackClick &&
                        (element.tagName === 'A' ||
                            element.tagName === 'BUTTON' ||
                            element.tagName === 'INPUT' ||
                            element.getAttribute('role')) &&
                        !element._isWatchTrack)) {
                    if (element.tagName === 'A') {
                        if (!/referrer\-id=/.test(element.href) && pageId && typeof pageId === 'string' && /\//.test(href)) {
                            if (/\?.*=/.test(element.href)) {
                                element.href = element.href.replace(/\?/, "?referrer-id=" + pageId + "&");
                            }
                            else if (/\?/.test(element.href) === false) {
                                element.href += "?referrer-id=" + pageId;
                            }
                        }
                        if (config.delayLink && /\//.test(href)) {
                            instance$1.trackLink(element);
                        }
                        else {
                            instance$1.trackDom(element);
                        }
                    }
                    else {
                        instance$1.trackDom(element);
                    }
                    hasTrack = true;
                }
                else if (element._isWatchTrack) {
                    hasTrack = true;
                }
                element = element.parentNode;
            }
            if (!hasTrack && e.target) {
                instance$1.trackDom(e.target);
            }
        }, false);
    };
    window.addEventListener('DOMContentLoaded', function () {
        var config = getConfig();
        if (config.autoInstall) {
            install();
        }
    });
    try {
        var ua = window.navigator.userAgent;
        var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
        var host = window.location.host;
        if (/(pre|qa|127|192)\.|localhost/.test(host) || (/env\((pre|qa)\)/i.test(ua) && !host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.qa.91jkys.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.qa.91jkys.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.qa.91jkys.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.qa.91jkys.com/duration.gif"
            });
        }
        else if (/zyhealth\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.zyhealth.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.zyhealth.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.zyhealth.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.zyhealth.com/duration.gif"
            });
        }
        else if (/dia-solution\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.dia-solution.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.dia-solution.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.dia-solution.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.dia-solution.com/duration.gif"
            });
        }
        else if (/c4-91jkys\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.c4-91jkys.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.c4-91jkys.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.c4-91jkys.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.c4-91jkys.com/duration.gif"
            });
        }
        else if (/c10-91jkys\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.c10-91jkys.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.c10-91jkys.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.c10-91jkys.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.c10-91jkys.com/duration.gif"
            });
        }
        if (/DeviceId/i.test(ua)) {
            var deviceIdMatch = ua.match(/DeviceId\((.*?)\)/);
            if (deviceIdMatch && deviceIdMatch.length >= 2) {
                setClientInfo({
                    deviceId: deviceIdMatch[1]
                });
            }
        }
        if (/AppInfo/i.test(ua)) {
            var AppInfoMatch = ua.match(/AppInfo\((.*?);(.*?)\)/);
            if (AppInfoMatch && AppInfoMatch.length >= 3) {
                setClientInfo({
                    appId: AppInfoMatch[1],
                    appVersion: AppInfoMatch[2],
                    appType: 'APP'
                });
            }
        }
        if (typeof Sailer !== 'undefined' && /AppInfo|tangyi/.test(ua)) {
            setConfig({
                autoInstall: false
            });
            var isReady_1 = false;
            Sailer.ready(function () {
                if (isReady_1) {
                    return;
                }
                isReady_1 = true;
                var uid = Sailer.getUserInfo().uid;
                if (uid > 0) {
                    login({ uid: uid });
                }
                if (!Sailer.getEventInfo) {
                    install();
                    return;
                }
                Sailer.nativeCall('getEventInfo', function (res) {
                    if (!res || !res.data) {
                        return;
                    }
                    var eventInfo = res.data;
                    if (eventInfo && eventInfo.items && eventInfo.items.length) {
                        setClientInfo({
                            channel: eventInfo.items[0].channel,
                            deviceId: eventInfo.deviceId,
                            appId: eventInfo.appId,
                            appVersion: eventInfo.version,
                            sessionId: eventInfo.items[0].sessionId
                        });
                        setPageInfo({
                            referrerId: eventInfo.items[0].pageId,
                            sourceEventId: eventInfo.items[0].trackId
                        });
                    }
                    install();
                });
            });
        }
        else {
            var uid = getCookie('user_id') || getCookie('wechat_uid');
            if (uid) {
                login({ uid: uid });
            }
        }
    }
    catch (error) {
        console.error(error);
    }
    function _curry3(fn) {
      return function f3(a, b, c) {
        switch (arguments.length) {
          case 0:
            return f3;
          case 1:
            return _isPlaceholder_1(a) ? f3 : _curry2_1(function (_b, _c) {
              return fn(a, _b, _c);
            });
          case 2:
            return _isPlaceholder_1(a) && _isPlaceholder_1(b) ? f3 : _isPlaceholder_1(a) ? _curry2_1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder_1(b) ? _curry2_1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _curry1_1(function (_c) {
              return fn(a, b, _c);
            });
          default:
            return _isPlaceholder_1(a) && _isPlaceholder_1(b) && _isPlaceholder_1(c) ? f3 : _isPlaceholder_1(a) && _isPlaceholder_1(b) ? _curry2_1(function (_a, _b) {
              return fn(_a, _b, c);
            }) : _isPlaceholder_1(a) && _isPlaceholder_1(c) ? _curry2_1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder_1(b) && _isPlaceholder_1(c) ? _curry2_1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _isPlaceholder_1(a) ? _curry1_1(function (_a) {
              return fn(_a, b, c);
            }) : _isPlaceholder_1(b) ? _curry1_1(function (_b) {
              return fn(a, _b, c);
            }) : _isPlaceholder_1(c) ? _curry1_1(function (_c) {
              return fn(a, b, _c);
            }) : fn(a, b, c);
        }
      };
    }
    var _curry3_1 = _curry3;
    var always =
    _curry1_1(function always(val) {
      return function () {
        return val;
      };
    });
    var always_1 = always;
    var Identity = function (x) {
      return {
        value: x,
        map: function (f) {
          return Identity(f(x));
        }
      };
    };
    var over =
    _curry3_1(function over(lens, f, x) {
      return lens(function (y) {
        return Identity(f(y));
      })(x).value;
    });
    var over_1 = over;
    var set =
    _curry3_1(function set(lens, v, x) {
      return over_1(lens, always_1(v), x);
    });
    var set_1 = set;
    function _isPlaceholder$1(a) {
      return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }
    function _curry1$1(fn) {
      return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder$1(a)) {
          return f1;
        } else {
          return fn.apply(this, arguments);
        }
      };
    }
    function _curry2$1(fn) {
      return function f2(a, b) {
        switch (arguments.length) {
          case 0:
            return f2;
          case 1:
            return _isPlaceholder$1(a) ? f2 : _curry1$1(function (_b) {
              return fn(a, _b);
            });
          default:
            return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f2 : _isPlaceholder$1(a) ? _curry1$1(function (_a) {
              return fn(_a, b);
            }) : _isPlaceholder$1(b) ? _curry1$1(function (_b) {
              return fn(a, _b);
            }) : fn(a, b);
        }
      };
    }
    function _arity(n, fn) {
      switch (n) {
        case 0:
          return function () {
            return fn.apply(this, arguments);
          };
        case 1:
          return function (a0) {
            return fn.apply(this, arguments);
          };
        case 2:
          return function (a0, a1) {
            return fn.apply(this, arguments);
          };
        case 3:
          return function (a0, a1, a2) {
            return fn.apply(this, arguments);
          };
        case 4:
          return function (a0, a1, a2, a3) {
            return fn.apply(this, arguments);
          };
        case 5:
          return function (a0, a1, a2, a3, a4) {
            return fn.apply(this, arguments);
          };
        case 6:
          return function (a0, a1, a2, a3, a4, a5) {
            return fn.apply(this, arguments);
          };
        case 7:
          return function (a0, a1, a2, a3, a4, a5, a6) {
            return fn.apply(this, arguments);
          };
        case 8:
          return function (a0, a1, a2, a3, a4, a5, a6, a7) {
            return fn.apply(this, arguments);
          };
        case 9:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
            return fn.apply(this, arguments);
          };
        case 10:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            return fn.apply(this, arguments);
          };
        default:
          throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
      }
    }
    function _curryN(length, received, fn) {
      return function () {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while (combinedIdx < received.length || argsIdx < arguments.length) {
          var result;
          if (combinedIdx < received.length && (!_isPlaceholder$1(received[combinedIdx]) || argsIdx >= arguments.length)) {
            result = received[combinedIdx];
          } else {
            result = arguments[argsIdx];
            argsIdx += 1;
          }
          combined[combinedIdx] = result;
          if (!_isPlaceholder$1(result)) {
            left -= 1;
          }
          combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
      };
    }
    var curryN =
    _curry2$1(function curryN(length, fn) {
      if (length === 1) {
        return _curry1$1(fn);
      }
      return _arity(length, _curryN(length, [], fn));
    });
    function _curry3$1(fn) {
      return function f3(a, b, c) {
        switch (arguments.length) {
          case 0:
            return f3;
          case 1:
            return _isPlaceholder$1(a) ? f3 : _curry2$1(function (_b, _c) {
              return fn(a, _b, _c);
            });
          case 2:
            return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f3 : _isPlaceholder$1(a) ? _curry2$1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder$1(b) ? _curry2$1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _curry1$1(function (_c) {
              return fn(a, b, _c);
            });
          default:
            return _isPlaceholder$1(a) && _isPlaceholder$1(b) && _isPlaceholder$1(c) ? f3 : _isPlaceholder$1(a) && _isPlaceholder$1(b) ? _curry2$1(function (_a, _b) {
              return fn(_a, _b, c);
            }) : _isPlaceholder$1(a) && _isPlaceholder$1(c) ? _curry2$1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder$1(b) && _isPlaceholder$1(c) ? _curry2$1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _isPlaceholder$1(a) ? _curry1$1(function (_a) {
              return fn(_a, b, c);
            }) : _isPlaceholder$1(b) ? _curry1$1(function (_b) {
              return fn(a, _b, c);
            }) : _isPlaceholder$1(c) ? _curry1$1(function (_c) {
              return fn(a, b, _c);
            }) : fn(a, b, c);
        }
      };
    }
    var _isArray = Array.isArray || function _isArray(val) {
      return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
    };
    function _isTransformer(obj) {
      return obj != null && typeof obj['@@transducer/step'] === 'function';
    }
    function _dispatchable(methodNames, xf, fn) {
      return function () {
        if (arguments.length === 0) {
          return fn();
        }
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!_isArray(obj)) {
          var idx = 0;
          while (idx < methodNames.length) {
            if (typeof obj[methodNames[idx]] === 'function') {
              return obj[methodNames[idx]].apply(obj, args);
            }
            idx += 1;
          }
          if (_isTransformer(obj)) {
            var transducer = xf.apply(null, args);
            return transducer(obj);
          }
        }
        return fn.apply(this, arguments);
      };
    }
    var _xfBase = {
      init: function () {
        return this.xf['@@transducer/init']();
      },
      result: function (result) {
        return this.xf['@@transducer/result'](result);
      }
    };
    function _map(fn, functor) {
      var idx = 0;
      var len = functor.length;
      var result = Array(len);
      while (idx < len) {
        result[idx] = fn(functor[idx]);
        idx += 1;
      }
      return result;
    }
    function _isString(x) {
      return Object.prototype.toString.call(x) === '[object String]';
    }
    var _isArrayLike =
    _curry1$1(function isArrayLike(x) {
      if (_isArray(x)) {
        return true;
      }
      if (!x) {
        return false;
      }
      if (typeof x !== 'object') {
        return false;
      }
      if (_isString(x)) {
        return false;
      }
      if (x.nodeType === 1) {
        return !!x.length;
      }
      if (x.length === 0) {
        return true;
      }
      if (x.length > 0) {
        return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
      }
      return false;
    });
    var XWrap =
    function () {
      function XWrap(fn) {
        this.f = fn;
      }
      XWrap.prototype['@@transducer/init'] = function () {
        throw new Error('init not implemented on XWrap');
      };
      XWrap.prototype['@@transducer/result'] = function (acc) {
        return acc;
      };
      XWrap.prototype['@@transducer/step'] = function (acc, x) {
        return this.f(acc, x);
      };
      return XWrap;
    }();
    function _xwrap(fn) {
      return new XWrap(fn);
    }
    var bind =
    _curry2$1(function bind(fn, thisObj) {
      return _arity(fn.length, function () {
        return fn.apply(thisObj, arguments);
      });
    });
    function _arrayReduce(xf, acc, list) {
      var idx = 0;
      var len = list.length;
      while (idx < len) {
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }
        idx += 1;
      }
      return xf['@@transducer/result'](acc);
    }
    function _iterableReduce(xf, acc, iter) {
      var step = iter.next();
      while (!step.done) {
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }
        step = iter.next();
      }
      return xf['@@transducer/result'](acc);
    }
    function _methodReduce(xf, acc, obj, methodName) {
      return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
    }
    var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
    function _reduce(fn, acc, list) {
      if (typeof fn === 'function') {
        fn = _xwrap(fn);
      }
      if (_isArrayLike(list)) {
        return _arrayReduce(fn, acc, list);
      }
      if (typeof list['fantasy-land/reduce'] === 'function') {
        return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
      }
      if (list[symIterator] != null) {
        return _iterableReduce(fn, acc, list[symIterator]());
      }
      if (typeof list.next === 'function') {
        return _iterableReduce(fn, acc, list);
      }
      if (typeof list.reduce === 'function') {
        return _methodReduce(fn, acc, list, 'reduce');
      }
      throw new TypeError('reduce: list must be array or iterable');
    }
    var XMap =
    function () {
      function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
      }
      XMap.prototype['@@transducer/init'] = _xfBase.init;
      XMap.prototype['@@transducer/result'] = _xfBase.result;
      XMap.prototype['@@transducer/step'] = function (result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
      };
      return XMap;
    }();
    var _xmap =
    _curry2$1(function _xmap(f, xf) {
      return new XMap(f, xf);
    });
    function _has$1(prop, obj) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var toString$1 = Object.prototype.toString;
    var _isArguments$1 =
    function () {
      return toString$1.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString$1.call(x) === '[object Arguments]';
      } : function _isArguments(x) {
        return _has$1('callee', x);
      };
    }();
    var hasEnumBug$1 = !
    {
      toString: null
    }.propertyIsEnumerable('toString');
    var nonEnumerableProps$1 = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
    var hasArgsEnumBug$1 =
    function () {
      return arguments.propertyIsEnumerable('length');
    }();
    var contains$1 = function contains(list, item) {
      var idx = 0;
      while (idx < list.length) {
        if (list[idx] === item) {
          return true;
        }
        idx += 1;
      }
      return false;
    };
    var keys$1 = typeof Object.keys === 'function' && !hasArgsEnumBug$1 ?
    _curry1$1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    _curry1$1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
      var prop, nIdx;
      var ks = [];
      var checkArgsLength = hasArgsEnumBug$1 && _isArguments$1(obj);
      for (prop in obj) {
        if (_has$1(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
      if (hasEnumBug$1) {
        nIdx = nonEnumerableProps$1.length - 1;
        while (nIdx >= 0) {
          prop = nonEnumerableProps$1[nIdx];
          if (_has$1(prop, obj) && !contains$1(ks, prop)) {
            ks[ks.length] = prop;
          }
          nIdx -= 1;
        }
      }
      return ks;
    });
    var map =
    _curry2$1(
    _dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
      switch (Object.prototype.toString.call(functor)) {
        case '[object Function]':
          return curryN(functor.length, function () {
            return fn.call(this, functor.apply(this, arguments));
          });
        case '[object Object]':
          return _reduce(function (acc, key) {
            acc[key] = fn(functor[key]);
            return acc;
          }, {}, keys$1(functor));
        default:
          return _map(fn, functor);
      }
    }));
    var _isInteger = Number.isInteger || function _isInteger(n) {
      return n << 0 === n;
    };
    var nth =
    _curry2$1(function nth(offset, list) {
      var idx = offset < 0 ? list.length + offset : offset;
      return _isString(list) ? list.charAt(idx) : list[idx];
    });
    var paths =
    _curry2$1(function paths(pathsArray, obj) {
      return pathsArray.map(function (paths) {
        var val = obj;
        var idx = 0;
        var p;
        while (idx < paths.length) {
          if (val == null) {
            return;
          }
          p = paths[idx];
          val = _isInteger(p) ? nth(p, val) : val[p];
          idx += 1;
        }
        return val;
      });
    });
    var path =
    _curry2$1(function path(pathAr, obj) {
      return paths([pathAr], obj)[0];
    });
    var prop =
    _curry2$1(function prop(p, obj) {
      return path([p], obj);
    });
    var assoc =
    _curry3$1(function assoc(prop, val, obj) {
      var result = {};
      for (var p in obj) {
        result[p] = obj[p];
      }
      result[prop] = val;
      return result;
    });
    var lens =
    _curry2$1(function lens(getter, setter) {
      return function (toFunctorFn) {
        return function (target) {
          return map(function (focus) {
            return setter(focus, target);
          }, toFunctorFn(getter(target)));
        };
      };
    });
    var lensProp =
    _curry1$1(function lensProp(k) {
      return lens(prop(k), assoc(k));
    });
    var tracker = function (partical) {
        if (typeof partical === 'function') {
            return function (target, key, descriptor) {
                var value = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var fn = partical.call(this, descriptor.value, this);
                    if (typeof fn === 'function') {
                        return fn.apply(this, args);
                    }
                    else {
                        if (typeof fn === 'object') {
                            var data = __assign({}, fn);
                            instance$1.trackEvent(data);
                        }
                        return descriptor.value.apply(this, arguments);
                    }
                };
                return set_1(lensProp('value'), value, descriptor);
            };
        }
        else if (typeof partical === 'object') {
            return function (target, key, descriptor) {
                var oldValue = descriptor.value;
                descriptor.value = function () {
                    var data = __assign({}, partical);
                    instance$1.trackEvent(data);
                    return oldValue.apply(this, arguments);
                };
                return descriptor;
            };
        }
        else {
            return function (target, key, descriptor) {
                var oldValue = descriptor.value;
                descriptor.value = function () {
                    var data = {
                        trackId: partical
                    };
                    instance$1.trackEvent(data);
                    return oldValue.apply(this, arguments);
                };
                return descriptor;
            };
        }
    };
    function _arity$1(n, fn) {
      switch (n) {
        case 0:
          return function () {
            return fn.apply(this, arguments);
          };
        case 1:
          return function (a0) {
            return fn.apply(this, arguments);
          };
        case 2:
          return function (a0, a1) {
            return fn.apply(this, arguments);
          };
        case 3:
          return function (a0, a1, a2) {
            return fn.apply(this, arguments);
          };
        case 4:
          return function (a0, a1, a2, a3) {
            return fn.apply(this, arguments);
          };
        case 5:
          return function (a0, a1, a2, a3, a4) {
            return fn.apply(this, arguments);
          };
        case 6:
          return function (a0, a1, a2, a3, a4, a5) {
            return fn.apply(this, arguments);
          };
        case 7:
          return function (a0, a1, a2, a3, a4, a5, a6) {
            return fn.apply(this, arguments);
          };
        case 8:
          return function (a0, a1, a2, a3, a4, a5, a6, a7) {
            return fn.apply(this, arguments);
          };
        case 9:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
            return fn.apply(this, arguments);
          };
        case 10:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            return fn.apply(this, arguments);
          };
        default:
          throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
      }
    }
    var _arity_1 = _arity$1;
    function _curryN$1(length, received, fn) {
      return function () {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while (combinedIdx < received.length || argsIdx < arguments.length) {
          var result;
          if (combinedIdx < received.length && (!_isPlaceholder_1(received[combinedIdx]) || argsIdx >= arguments.length)) {
            result = received[combinedIdx];
          } else {
            result = arguments[argsIdx];
            argsIdx += 1;
          }
          combined[combinedIdx] = result;
          if (!_isPlaceholder_1(result)) {
            left -= 1;
          }
          combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : _arity_1(left, _curryN$1(length, combined, fn));
      };
    }
    var _curryN_1 = _curryN$1;
    var curryN$1 =
    _curry2_1(function curryN(length, fn) {
      if (length === 1) {
        return _curry1_1(fn);
      }
      return _arity_1(length, _curryN_1(length, [], fn));
    });
    var curryN_1 = curryN$1;
    var before = curryN_1(2, function (trackFn, fn) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (typeof trackFn === 'function') {
                try {
                    var result = trackFn.apply(this, args);
                    if (typeof result === 'object') {
                        instance$1.track(result);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            else if (typeof trackFn === 'object') {
                instance$1.track(trackFn);
            }
            else if (typeof trackFn === 'string') {
                var data = {
                    trackId: trackFn
                };
                instance$1.track(data);
            }
            var evalF = function () {
                var _this = this;
                setTimeout(function () {
                    fn.apply(_this, args);
                }, 300);
            };
            return evalF.apply(this);
        };
    });
    var after = curryN_1(2, function (trackFn, fn) {
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var r = fn.apply(this, args);
            var evalF = function () {
                if (typeof trackFn === 'function') {
                    try {
                        var result = trackFn.apply(_this, args);
                        if (typeof result === 'object') {
                            instance$1.track(result);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                else if (typeof trackFn === 'object') {
                    instance$1.track(trackFn);
                }
                else if (typeof trackFn === 'string') {
                    var data = {
                        trackId: trackFn
                    };
                    instance$1.track(data);
                }
            };
            if (isThenable(r)) {
                return r.then(function (rr) {
                    evalF();
                    return rr;
                });
            }
            evalF();
            return r;
        };
    });
    var findIndex = function (arr, callback) {
        for (var i = 0, len = arr.length; i < len; i++) {
            if (callback(arr[i], i)) {
                return i;
            }
        }
        return -1;
    };
    var generate = function (type) {
        var watch = [];
        var track = {
            bind: function (el, binding, vnode) {
                var index = findIndex(watch, function (element) { return element === el; });
                var isWatched = index !== -1;
                if (el.style.display === 'none') {
                    if (!isWatched)
                        watch.push(el);
                    return;
                }
                else {
                    if (isWatched)
                        watch.splice(index, 1);
                }
                if (!isWatched && (notChanged(binding) || isEmpty(binding)))
                    return;
                var info = {};
                if (typeof binding.value === 'object') {
                    info = binding.value;
                }
                else if (typeof binding.value === 'string' && binding.value) {
                    info.trackId = binding.value;
                }
                if (type === 'PAGE') {
                    instance$1.trackPage(info);
                }
                else {
                    instance$1.trackView(el, info);
                }
            },
            unbind: function (el, binding) {
                var index = findIndex(watch, function (element) { return element === el; });
                if (index !== -1)
                    watch.splice(index, 1);
                if (type !== 'PAGE') {
                    var info = {};
                    if (typeof binding.value === 'object') {
                        info = binding.value;
                    }
                    else if (typeof binding.value === 'string' && binding.value) {
                        info.trackId = binding.value;
                    }
                    if (info.trackId) {
                        instance.end(info);
                    }
                }
            },
            update: function (el, binding, vnode) { }
        };
        track.update = track.bind;
        return track;
    };
    var trackView = generate('VIEW');
    function trackEvent (el, binding) {
        if (notChanged(binding) || isEmpty(binding)) {
            return;
        }
        var info = {};
        if (typeof binding.value === 'object' && binding.value) {
            info = binding.value;
        }
        else if (typeof binding.value === 'string') {
            info.trackId = binding.value;
        }
        else if (typeof binding.value === 'number') {
            info.trackId = binding.value + '';
        }
        el._trackerInfo = info;
        el._isWatchTrack = true;
        var events = Object.keys(binding.modifiers).filter(function (modifier) {
            return binding.modifiers[modifier];
        });
        if (!events.length)
            events.push('click');
        events.forEach(function (event) {
            el.removeEventListener(event, handleEvent, true);
            el.addEventListener(event, handleEvent, true);
        });
    }
    function handleEvent(e) {
        this._trackerInfo.eventName = e.type.toUpperCase();
        if (this.tagName === 'A' && this.href) {
            instance$1.trackLink(this, this._trackerInfo);
        }
        else {
            instance$1.trackDom(this, this._trackerInfo);
        }
    }
    var trackPage = generate('PAGE');
    var trackDom = instance$1.trackDom;
    var trackPage$1 = instance$1.trackPage;
    var trackEvent$1 = instance$1.trackEvent;
    var trackLog = instance$1.trackLog;
    var trackViewStart = instance$1.trackViewStart;
    var trackViewEnd = instance$1.trackViewEnd;
    var trackView$1 = instance$1.trackView;
    var trackLink = instance$1.trackLink;
    var track = instance$1.track;
    if (typeof XMLHttpRequest === 'undefined') {
        throw new Error('tracker requires ie10+');
    }
    try {
        "production";
    }
    catch (e) {
        var g = typeof window !== 'undefined' ? window : commonjsGlobal;
        if (typeof g.process === 'undefined')
            g.process = {};
        g.process.env = {};
    }
    if (typeof _TrackerGlobalData === 'undefined') {
        window._TrackerGlobalData = {};
    }
    exports.actionTracker = instance$1;
    exports.after = after;
    exports.before = before;
    exports.getConfig = getConfig;
    exports.install = install;
    exports.login = login;
    exports.logout = logout;
    exports.send = send;
    exports.sendAsync = sendAsync;
    exports.sendSync = sendSync;
    exports.setConfig = setConfig;
    exports.track = track;
    exports.trackDom = trackDom;
    exports.trackEvent = trackEvent$1;
    exports.trackLink = trackLink;
    exports.trackLog = trackLog;
    exports.trackPage = trackPage$1;
    exports.trackView = trackView$1;
    exports.trackViewEnd = trackViewEnd;
    exports.trackViewStart = trackViewStart;
    exports.tracker = tracker;
    exports.vTrackEvent = trackEvent;
    exports.vTrackPage = trackPage;
    exports.vTrackView = trackView;
    Object.defineProperty(exports, '__esModule', { value: true });
}));
});

var defaultOptions = {
    needLogin: true,
    mallSass: false,
    baseURL: '',
    domain: window.location.origin + "/f2e/checkout-web/",
    bizId: '',
    bizSource: '',
    backEventType: 0,
    payWay: []
};
var BaseConfig = (function () {
    function BaseConfig() {
        this.options = defaultOptions;
        this.initTimes = 0;
    }
    BaseConfig.prototype.init = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var adaptParam_1, adaptKey_1, extraConfig, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        telescope_min.setConfig({ autoTrackClick: false, trackKey: 'acd2bf9921d1c93e260c4626e1a7d88b', version: '1.0.0' });
                        this.options = __assign(__assign(__assign({}, this.options), options), { domain: options.domain || this.options.domain });
                        if (this.options.bizSource) {
                            telescope_min.setConfig({
                                beforeGenerateLog: function (log) {
                                    return (__assign(__assign({}, log), { custom: __assign({ bizSource: _this.options.bizSource }, log.custom) }));
                                }
                            });
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        adaptParam_1 = {};
                        adaptKey_1 = ['bizId', 'baseURL', 'loginKey', 'wechatLoginApi', 'jkysWechatURL'];
                        Object.keys(this.options).forEach(function (el) {
                            if (adaptKey_1.includes(el)) {
                                adaptParam_1[el] = _this.options[el];
                            }
                        });
                        extraConfig = adaptConfig[this.options.bizId] || {};
                        if (adaptParam_1.bizId === 'C_TERMINAL') {
                            extraConfig.checkOpenIdType = 'ZYJK_SUBSCRIBE';
                            if (env.inAPP) {
                                extraConfig.checkOpenIdType = 'ZYJK_APP';
                            }
                            else if (env.inWechatMiniProgram) {
                                extraConfig.checkOpenIdType = 'ZYJK_APPLET';
                            }
                        }
                        else {
                            delete extraConfig.checkOpenIdType;
                        }
                        this.initTimes = 0;
                        return [4, this.doInitAdapter(__assign(__assign({}, adaptParam_1), extraConfig))];
                    case 2:
                        _a.sent();
                        this.env = env;
                        if (!(env.inWechat && this.options.needLogin)) return [3, 4];
                        return [4, this.queryOpenId()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.payUA = getPayUa();
                        telescope_min.trackLog({
                            trackId: 'checkout-sdk-pay-init',
                            custom: __assign({ payUA: this.payUA, bizOpenId: this.bizOpenId, bizSource: this.options.bizSource }, this.options)
                        });
                        return [3, 6];
                    case 5:
                        error_1 = _a.sent();
                        telescope_min.trackLog({
                            trackId: 'checkout-sdk-pay-init-error',
                            custom: __assign({ error: error_1 }, this.options)
                        });
                        return [3, 6];
                    case 6: return [2];
                }
            });
        });
    };
    BaseConfig.prototype.queryOpenId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bizId, ua, bizOpenId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bizId = this.options.bizId;
                        ua = 'pub';
                        if (bizId === 'C_TERMINAL' && env.inWechatMiniProgram) {
                            ua = 'mini';
                        }
                        return [4, getOpenId({
                                bizId: bizId,
                                ua: ua
                            })];
                    case 1:
                        bizOpenId = (_a.sent()).data.bizOpenId;
                        this.bizOpenId = bizOpenId;
                        return [2];
                }
            });
        });
    };
    BaseConfig.prototype.doInitAdapter = function (adaptParam) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 5]);
                        if (!(!this.adapter && this.initTimes < 3)) return [3, 2];
                        this.initTimes++;
                        return [4, initAdapter(__assign({}, adaptParam))];
                    case 1:
                        _a.sent();
                        this.adapter = getAdapter();
                        _a.label = 2;
                    case 2: return [3, 5];
                    case 3:
                        _a.sent();
                        return [4, this.doInitAdapter(adaptParam)];
                    case 4:
                        _a.sent();
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    return BaseConfig;
}());

var version$1 = {
  v: '2.2.22'
};

var stash = {
};

var error = function PingppError(message, extra) {
  this.message = message;
  this.extra = extra;
};
var errors = {
  Error: error,
};

var PingppError$1 = errors.Error;
var hasOwn$o = {}.hasOwnProperty;
var payment_elements = {
  id: null,
  or_id: null,
  channel: null,
  app: null,
  credential: {},
  extra: null,
  livemode: null,
  order_no: null,
  time_expire: null,
  paid: false,
  status: null,
  actual_amount: null,
  init: function (charge_or_order) {
    var charge;
    if (typeof charge_or_order === 'string') {
      try {
        charge = JSON.parse(charge_or_order);
      } catch (err) {
        throw new PingppError$1('json_decode_fail', err);
      }
    } else {
      charge = charge_or_order;
    }
    if (typeof charge === 'undefined') {
      throw new PingppError$1('json_decode_fail');
    }
    if (hasOwn$o.call(charge, 'object') && charge.object == 'order') {
      charge.or_id = charge.id;
      charge.order_no = charge.merchant_order_no;
      var charge_essentials = charge.charge_essentials;
      charge.channel = charge_essentials.channel;
      charge.credential = charge_essentials.credential;
      charge.extra = charge_essentials.extra;
      if(hasOwn$o.call(charge, 'charge') && charge.charge != null) {
        charge.id = charge.charge;
      } else if(hasOwn$o.call(charge_essentials, 'id')
        && charge_essentials.id != null) {
        charge.id = charge_essentials.id;
      } else if(hasOwn$o.call(charge, 'charges')) {
        for(var i = 0; i < charge.charges.data.length; i++){
          if(charge.charges.data[i].channel === charge_essentials.channel) {
            charge.id = charge.charges.data[i].id;
            break;
          }
        }
      }
    } else if(hasOwn$o.call(charge, 'object') && charge.object == 'recharge') {
      charge = charge.charge;
    }
    for (var key in this) {
      if (hasOwn$o.call(charge, key)) {
        this[key] = charge[key];
      }
    }
    return this;
  },
  clear: function () {
    for (var key in this) {
      if (typeof this[key] !== 'function') {
        this[key] = null;
      }
    }
  }
};

var callbacks = {
  userCallback: undefined,
  urlReturnCallback: undefined,
  urlReturnChannels: [
    'alipay_pc_direct',
  ],
  userAgreementCallback: undefined,
  innerCallback: function(result, err) {
    if (typeof this.userCallback === 'function') {
      if (typeof err === 'undefined') {
        err = this.error();
      }
      this.userCallback(result, err);
      this.userCallback = undefined;
      var payment_elements$1 = payment_elements;
      payment_elements$1.clear();
    }
  },
  error: function(msg, extra) {
    msg = (typeof msg === 'undefined') ? '' : msg;
    extra = (typeof extra === 'undefined') ? '' : extra;
    return {
      msg: msg,
      extra: extra
    };
  },
  triggerUrlReturnCallback: function (err, url) {
    if (typeof this.urlReturnCallback === 'function') {
      this.urlReturnCallback(err, url);
    }
  },
  shouldReturnUrlByCallback: function (channel) {
    if (typeof this.urlReturnCallback !== 'function') {
      return false;
    }
    return this.urlReturnChannels.indexOf(channel) !== -1;
  },
  innerAgreementCallback: function(result, err) {
    if (typeof this.userAgreementCallback === 'function') {
      if (typeof err === 'undefined') {
        err = this.error();
      }
      this.userAgreementCallback(result, err);
      this.userAgreementCallback = undefined;
    }
  }
};

var utils_1 = createCommonjsModule(function (module) {
var hasOwn = {}.hasOwnProperty;
var utils = module.exports = {
  stringifyData: function (data, channel, urlencode) {
    if (typeof urlencode == 'undefined') {
      urlencode = false;
    }
    var output = [];
    for (var i in data) {
      if (!hasOwn.call(data, i) || typeof data[i] === 'function') {
        continue;
      }
      if (channel == 'bfb_wap' && i == 'url') {
        continue;
      }
      if (channel == 'yeepay_wap' && i == 'mode') {
        continue;
      }
      if (i == 'channel_url') {
        continue;
      }
      output.push(i + '=' +
          (urlencode ? encodeURIComponent(data[i]) : data[i]));
    }
    return output.join('&');
  },
  request: function (url, method, requestData,
    successCallback, errorCallback, headers) {
    if (typeof XMLHttpRequest === 'undefined') {
      console.log('Function XMLHttpRequest is undefined.');
      return;
    }
    var xhr = new XMLHttpRequest();
    if (typeof xhr.timeout !== 'undefined') {
      xhr.timeout = 6000;
    }
    method = method.toUpperCase();
    if (method === 'GET' && typeof requestData === 'object' && requestData) {
      url += '?' + utils.stringifyData(requestData, '', true);
    }
    xhr.open(method, url, true);
    if (typeof headers !== 'undefined') {
      for (var k in headers) {
        if (hasOwn.call(headers, k)) {
          xhr.setRequestHeader(k, headers[k]);
        }
      }
    }
    if (method === 'POST') {
      xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
      xhr.send(JSON.stringify(requestData));
    } else {
      xhr.send();
    }
    if (typeof successCallback == 'undefined') {
      successCallback = function () {};
    }
    if (typeof errorCallback == 'undefined') {
      errorCallback = function () {};
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        successCallback(xhr.responseText, xhr.status, xhr);
      }
    };
    xhr.onerror = function (e) {
      errorCallback(xhr, 0, e);
    };
  },
  formSubmit: function (url, method, params) {
    if (typeof window === 'undefined') {
      console.log('Not a browser, form submit url: ' + url);
      return;
    }
    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', url);
    for (var key in params) {
      if (hasOwn.call(params, key)) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  },
  randomString: function (length) {
    if (typeof length == 'undefined') {
      length = 32;
    }
    var chars =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var maxPos = chars.length;
    var str = '';
    for (var i = 0; i < length; i++) {
      str += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return str;
  },
  redirectTo: function (url, channel) {
    if (callbacks.shouldReturnUrlByCallback(channel)) {
      callbacks.triggerUrlReturnCallback(null, url);
      return;
    }
    if (typeof window === 'undefined') {
      console.log('Not a browser, redirect url: ' + url);
      return;
    }
    window.location.href = url;
  },
  inWeixin: function () {
    if (typeof navigator === 'undefined') {
      return false;
    }
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
  },
  inAlipay: function () {
    if (typeof navigator === 'undefined') {
      return false;
    }
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('alipayclient') !== -1;
  },
  inWxLite: function() {
    if(typeof wx === 'undefined') {
      return false;
    }
    return wx.miniProgram || wx.requestPayment;
  },
  inAlipayLite: function() {
    if(typeof my === 'undefined') {
      return false;
    }
    return my.tradePay;
  },
  documentReady: function (fn) {
    if (typeof document === 'undefined') {
      fn();
      return;
    }
    if (document.readyState != 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  },
  loadUrlJs: function (sid, jsurl, callback) {
    var nodeHead = document.getElementsByTagName('head')[0];
    var nodeScript = null;
    if (document.getElementById(sid) == null) {
      nodeScript = document.createElement('script');
      nodeScript.setAttribute('type', 'text/javascript');
      nodeScript.setAttribute('src', jsurl);
      nodeScript.setAttribute('id', sid);
      nodeScript.async = true;
      if (callback != null) {
        nodeScript.onload = nodeScript.onreadystatechange = function () {
          if (nodeScript.ready) {
            return false;
          }
          if (!nodeScript.readyState || nodeScript.readyState == 'loaded'
              || nodeScript.readyState == 'complete') {
            nodeScript.ready = true;
            callback();
          }
        };
      }
      nodeHead.appendChild(nodeScript);
    } else {
      if (callback != null) {
        callback();
      }
    }
  }
};
});

var init = {
  init: function() {
    var self = this;
    utils_1.documentReady(function(){
      try {
        (!(utils_1.inWxLite() || utils_1.inAlipayLite())) && self.initPuid();
      } catch (e){}
    });
  },
  initPuid: function() {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined'
        || localStorage === null) {
      return;
    }
    var puid = localStorage.getItem('pingpp_uid');
    if (puid === null) {
      puid = utils_1.randomString();
      try {
        localStorage.setItem('pingpp_uid', puid);
      } catch (e) {
      }
    }
    stash.puid = puid;
  }
};

var hasOwn$n = {}.hasOwnProperty;
var testmode = {
  PINGPP_MOCK_URL: 'http://sissi.pingxx.com/mock.php',
  runTestMode: function (charge) {
    var params = {
      'ch_id': charge.id,
      'scheme': 'http',
      'channel': charge.channel
    };
    if (hasOwn$n.call(charge, 'order_no')) {
      params.order_no = charge.order_no;
    } else if (hasOwn$n.call(charge, 'orderNo')) {
      params.order_no = charge.orderNo;
    }
    if (hasOwn$n.call(charge, 'time_expire')) {
      params.time_expire = charge.time_expire;
    } else if (hasOwn$n.call(charge, 'timeExpire')) {
      params.time_expire = charge.timeExpire;
    }
    if (hasOwn$n.call(charge, 'extra')) {
      params.extra = encodeURIComponent(JSON.stringify(charge.extra));
    }
    utils_1.redirectTo(
      this.PINGPP_MOCK_URL + '?' + utils_1.stringifyData(params),
      charge.channel
    );
  }
};

var hasOwn$m = {}.hasOwnProperty;
var alipay = {
  PINGPP_NOTIFY_URL_BASE: 'https://notify.pingxx.com/notify',
  handleCharge: function (charge) {
    var credential = charge.credential[charge.channel];
    if (credential || hasOwn$m.call(credential, 'orderInfo')) {
      this.callpay(credential.orderInfo);
    } else {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_credential', 'missing_alipay'));
    }
  },
  alipayLiteEnabled: function () {
    return typeof my !== 'undefined' && my.tradePay;
  },
  callpay: function (orderStr) {
    var self = this;
    if (this.alipayLiteEnabled()) {
      return this.alipayLitePay(orderStr);
    }
    if (typeof navigator !== 'undefined'
      && /AlipayClient/.test(navigator.userAgent || navigator.swuserAgent)) {
      return this.waitAlipayJSBridgde(function () {
        self.alipayJsBridgePay(orderStr);
      });
    }
    var errmsg = '请在支付宝小程序或者支付宝应用内中打开';
    console.log(errmsg);
    callbacks.innerCallback('fail', callbacks.error(errmsg));
    return;
  },
  waitAlipayJSBridgde: function (callback) {
    if (window.AlipayJSBridge) {
      callback && callback();
    } else {
      document.addEventListener('AlipayJSBridgeReady', callback, false);
    }
  },
  alipayJsBridgePay: function (orderStr) {
    AlipayJSBridge.call('tradePay', {
      orderStr: orderStr
    }, this.alipayResultHandler);
  },
  alipayLitePay: function (orderStr) {
    var tradePayParams = {};
    tradePayParams.orderStr = orderStr;
    tradePayParams.complete = this.alipayResultHandler;
    my.tradePay(tradePayParams);
  },
  alipayResultHandler: function (res) {
    var extra = {
      resultCode: res.resultCode
    };
    if (hasOwn$m.call(res, 'memo')) {
      extra.memo = res.memo;
    }
    if (hasOwn$m.call(res, 'result')) {
      extra.result = res.result;
    }
    if (res.resultCode == '9000') {
      callbacks.innerCallback('success', callbacks.error('', extra));
    } else if (res.resultCode == '6001') {
      callbacks.innerCallback('cancel', callbacks.error('用户取消支付', extra));
    } else {
      callbacks.innerCallback('fail', callbacks.error('支付失败', extra));
    }
  },
  runTestMode: function (charge) {
    var path = '/charges/' + charge.id;
    my.httpRequest({
      url: this.PINGPP_NOTIFY_URL_BASE + path + '?livemode=false',
      success: function(res) {
        if (res.data == 'success') {
          callbacks.innerCallback('success');
        } else {
          callbacks.innerCallback('fail',
            callbacks.error('testmode_notify_fail'));
        }
      },
      fail:function() {
        callbacks.innerCallback('fail', callbacks.error('network_err'));
      }
    });
  }
};

var alipay_lite = {
  PINGPP_NOTIFY_URL_BASE: 'https://notify.pingxx.com/notify',
  handleCharge: function (charge) {
    var trade_no = charge.credential[charge.channel];
    if (trade_no) {
      this.callpay(trade_no);
    } else {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_credential', 'missing_alipay_lite'));
    }
  },
  alipayLiteEnabled: function () {
    return typeof my !== 'undefined' && my.tradePay;
  },
  callpay: function (tradeNO) {
    if (!this.alipayLiteEnabled()) {
      console.log('请在支付宝小程序中打开');
      return;
    }
    var alipay_lite = {};
    alipay_lite.tradeNO = tradeNO;
    alipay_lite.complete = function (res) {
      if (res.resultCode == 9000) {
        callbacks.innerCallback('success');
      } else if (res.resultCode == 6001) {
        callbacks.innerCallback('cancel', callbacks.error('用户取消支付'));
      } else {
        callbacks.innerCallback('fail', callbacks.error('支付失败'));
      }
    };
    my.tradePay(alipay_lite);
  },
  runTestMode: function (charge) {
    var path = '/charges/' + charge.id;
    my.httpRequest({
      url: this.PINGPP_NOTIFY_URL_BASE + path + '?livemode=false',
      success: function(res) {
        if (res.data == 'success') {
          callbacks.innerCallback('success');
        } else {
          callbacks.innerCallback('fail',
            callbacks.error('testmode_notify_fail'));
        }
      },
      fail:function() {
        callbacks.innerCallback('fail', callbacks.error('network_err'));
      }
    });
  }
};

var hasOwn$l = {}.hasOwnProperty;
var alipay_pc_direct = {
  ALIPAY_PC_DIRECT_URL: 'https://mapi.alipay.com/gateway.do',
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    var baseURL = this.ALIPAY_PC_DIRECT_URL;
    if (hasOwn$l.call(credential, 'channel_url')) {
      baseURL = credential.channel_url;
    }
    if (!hasOwn$l.call(credential, '_input_charset')) {
      if(hasOwn$l.call(credential, 'service')
        && credential.service === 'create_direct_pay_by_user') {
        credential._input_charset = 'utf-8';
      }
    }
    var query = utils_1.stringifyData(credential, channel, true);
    utils_1.redirectTo(baseURL + '?' + query, channel);
  }
};

var hasOwn$k = {}.hasOwnProperty;
var alipay_qr = {
  handleCharge: function (charge) {
    var credential = charge.credential[charge.channel];
    if (hasOwn$k.call(credential, 'transaction_no')) {
      this.tradePay(credential.transaction_no);
    } else {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_credential', 'missing_field_transaction_no'));
    }
  },
  ready: function (callback) {
    if (window.AlipayJSBridge) {
      callback && callback();
    } else {
      document.addEventListener('AlipayJSBridgeReady', callback, false);
    }
  },
  tradePay: function (tradeNO) {
    this.ready(function () {
      AlipayJSBridge.call('tradePay', {
        tradeNO: tradeNO
      }, function (data) {
        if ('9000' == data.resultCode) {
          callbacks.innerCallback('success');
        } else if('6001' == data.resultCode) {
          callbacks.innerCallback('cancel', callbacks.error(data.result));
        } else {
          callbacks.innerCallback('fail',
            callbacks.error(data.result));
        }
      });
    });
  }
};

var hasOwn$j = {}.hasOwnProperty;
var redirect_base = {
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    var targetURL;
    if (typeof credential === 'string') {
      targetURL = credential;
    } else if (hasOwn$j.call(credential, 'url')) {
      targetURL = credential.url;
    } else {
      callbacks.innerCallback('fail', callbacks.error('invalid_credential',
        'credential format is incorrect'));
      return;
    }
    utils_1.redirectTo(targetURL, charge.channel);
  }
};

var alipay_qr_lakala = {
  handleCharge: function(charge) {
    redirect_base.handleCharge(charge);
  }
};

var hasOwn$i = {}.hasOwnProperty;
var alipay_wap = {
  ALIPAY_WAP_URL_OLD: 'https://wappaygw.alipay.com/service/rest.htm',
  ALIPAY_WAP_URL: 'https://mapi.alipay.com/gateway.do',
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    var baseURL = this.ALIPAY_WAP_URL;
    if (hasOwn$i.call(credential, 'req_data')) {
      baseURL = this.ALIPAY_WAP_URL_OLD;
    } else if (hasOwn$i.call(credential, 'channel_url')) {
      baseURL = credential.channel_url;
    }
    if (!hasOwn$i.call(credential, '_input_charset')) {
      if ((hasOwn$i.call(credential, 'service')
          && credential.service === 'alipay.wap.create.direct.pay.by.user')
        || hasOwn$i.call(credential, 'req_data')
      ) {
        credential._input_charset = 'utf-8';
      }
    }
    var query = utils_1.stringifyData(credential, channel, true);
    var targetURL = baseURL + '?' + query;
    var ap = mods_1.getExtraModule('ap');
    if (utils_1.inWeixin() && typeof ap !== 'undefined') {
      ap.pay(targetURL);
    } else {
      utils_1.redirectTo(targetURL, channel);
    }
  }
};

var alipay_wap_lakala = {
  handleCharge: function(charge) {
    redirect_base.handleCharge(charge);
  }
};

var hasOwn$h = {}.hasOwnProperty;
var bfb_wap = {
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    if (!hasOwn$h.call(credential, 'url')) {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_credential', 'missing_field:url'));
      return;
    }
    utils_1.redirectTo(credential.url + '?' +
      utils_1.stringifyData(credential, channel), channel);
  }
};

var hasOwn$g = {}.hasOwnProperty;
var cb_alipay_pc_direct = {
  ALIPAY_PC_DIRECT_URL: 'https://intlmapi.alipay.com/gateway.do',
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    var baseURL = this.ALIPAY_PC_DIRECT_URL;
    if (hasOwn$g.call(credential, 'channel_url')) {
      baseURL = credential.channel_url;
    }
    if (!hasOwn$g.call(credential, '_input_charset')) {
      if(hasOwn$g.call(credential, 'service')
        && credential.service === 'create_forex_trade') {
        credential._input_charset = 'utf-8';
      }
    }
    var query = utils_1.stringifyData(credential, channel, true);
    utils_1.redirectTo(baseURL + '?' + query, channel);
  }
};

var hasOwn$f = {}.hasOwnProperty;
var cb_alipay_wap = {
  ALIPAY_WAP_URL: 'https://intlmapi.alipay.com/gateway.do',
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    var baseURL = this.ALIPAY_WAP_URL;
    if (hasOwn$f.call(credential, 'channel_url')) {
      baseURL = credential.channel_url;
    }
    if (!hasOwn$f.call(credential, '_input_charset')) {
      if ((hasOwn$f.call(credential, 'service')
          && credential.service === 'create_forex_trade_wap')
      ) {
        credential._input_charset = 'utf-8';
      }
    }
    var query = utils_1.stringifyData(credential, channel, true);
    var targetURL = baseURL + '?' + query;
    var ap = mods_1.getExtraModule('ap');
    if (utils_1.inWeixin() && typeof ap !== 'undefined') {
      ap.pay(targetURL);
    } else {
      utils_1.redirectTo(targetURL, channel);
    }
  }
};

var hasOwn$e = {}.hasOwnProperty;
var cb_wx_pub = {
  PINGPP_NOTIFY_URL_BASE: 'https://notify.pingxx.com/notify',
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    var fields = [
      'appId', 'timeStamp', 'nonceStr', 'package', 'signType', 'paySign'
    ];
    for (var k = 0; k < fields.length; k++) {
      if (!hasOwn$e.call(credential, fields[k])) {
        callbacks.innerCallback('fail',
          callbacks.error('invalid_credential', 'missing_field_' + fields[k]));
        return;
      }
    }
    stash.jsApiParameters = credential;
    this.callpay();
  },
  callpay: function() {
    var self = this;
    var wx_jssdk = mods_1.getExtraModule('wx_jssdk');
    if (typeof wx_jssdk !== 'undefined' && wx_jssdk.jssdkEnabled()) {
      wx_jssdk.callpay();
    } else if (typeof WeixinJSBridge == 'undefined') {
      var eventCallback = function() {
        self.jsApiCall();
      };
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady',
          eventCallback, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', eventCallback);
        document.attachEvent('onWeixinJSBridgeReady', eventCallback);
      }
    } else {
      this.jsApiCall();
    }
  },
  jsApiCall: function() {
    if (hasOwn$e.call(stash, 'jsApiParameters')) {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        stash.jsApiParameters,
        function(res) {
          delete stash.jsApiParameters;
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            callbacks.innerCallback('success');
          } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
            callbacks.innerCallback('cancel');
          } else {
            callbacks.innerCallback('fail',
              callbacks.error('wx_result_fail', res.err_msg));
          }
        }
      );
    }
  },
  runTestMode: function(charge) {
    var dopay = confirm('模拟付款？');
    if (dopay) {
      var path = '/charges/' + charge.id;
      utils_1.request(this.PINGPP_NOTIFY_URL_BASE + path + '?livemode=false',
        'GET', null,
        function(data, status) {
          if (status >= 200 && status < 400 && data == 'success') {
            callbacks.innerCallback('success');
          } else {
            var extra = 'http_code:' + status + ';response:' + data;
            callbacks.innerCallback('fail',
              callbacks.error('testmode_notify_fail', extra));
          }
        },
        function() {
          callbacks.innerCallback('fail', callbacks.error('network_err'));
        });
    }
  }
};

var ccb_qr = {
  handleCharge: function(charge) {
    redirect_base.handleCharge(charge);
  }
};

var hasOwn$d = {}.hasOwnProperty;
var ccb_wap = {
  CCB_WAP_URL_BASE: 'https://ibsbjstar.ccb.com.cn/CCBIS/ccbMain?',
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    if (!hasOwn$d.call(credential, 'orderinfo')) {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_credential', 'missing_field:orderinfo'));
      return;
    }
    var targetURL = this.CCB_WAP_URL_BASE + credential['orderinfo'];
    utils_1.redirectTo(targetURL, channel);
  }
};

var hasOwn$c = {}.hasOwnProperty;
var cmb_pc_qr = {
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    var baseURL;
    if (hasOwn$c.call(credential, 'channel_url')) {
      baseURL = credential.channel_url;
      delete credential.channel_url;
    }
    utils_1.formSubmit(baseURL, 'post', credential);
  }
};

var hasOwn$b = {}.hasOwnProperty;
var cmb_wallet = {
  CMB_WALLET_URL:
    'https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_EUserPay',
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    var request_url = this.CMB_WALLET_URL;
    if (hasOwn$b.call(credential, 'ChannelUrl')) {
      request_url = credential.ChannelUrl;
      delete credential.ChannelUrl;
    }
    if (hasOwn$b.call(credential, 'channelVersion')) {
      delete credential.channelVersion;
    }
    utils_1.formSubmit(request_url, 'post', credential);
  }
};

var coolcredit = {
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    utils_1.formSubmit(credential.request_url, 'post', credential.request_data);
  }
};

var cp_b2b = {
  CP_B2B_URL: 'https://payment.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0',
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    utils_1.formSubmit(this.CP_B2B_URL, 'post', credential);
  }
};

var hasOwn$a = {}.hasOwnProperty;
var wx_lite = {
  PINGPP_NOTIFY_URL_BASE: 'https://notify.pingxx.com/notify',
  handleCharge: function (charge) {
    var credential = charge.credential[charge.channel];
    var fields = [
      'appId', 'timeStamp', 'nonceStr', 'package', 'signType', 'paySign'
    ];
    for (var k = 0; k < fields.length; k++) {
      if (!hasOwn$a.call(credential, fields[k])) {
        callbacks.innerCallback('fail',
          callbacks.error('invalid_credential', 'missing_field_' + fields[k]));
        return;
      }
    }
    stash.jsApiParameters = credential;
    this.callpay();
  },
  wxLiteEnabled: function () {
    return typeof wx !== 'undefined' && wx.requestPayment;
  },
  callpay: function () {
    if (!this.wxLiteEnabled()) {
      console.log('请在微信小程序中打开');
      return;
    }
    var wx_lite = stash.jsApiParameters;
    delete wx_lite.appId;
    wx_lite.complete = function (res) {
      if (res.errMsg === 'requestPayment:ok') {
        callbacks.innerCallback('success');
      }
      if (res.errMsg === 'requestPayment:cancel'
        || res.errMsg === 'requestPayment:fail cancel') {
        callbacks.innerCallback('cancel', callbacks.error('用户取消支付'));
      }
      if (res.err_code !== 'undefined' && res.err_desc !== 'undefined') {
        callbacks.innerCallback('fail', callbacks.error(res.err_desc, res));
      }
    };
    wx.requestPayment(wx_lite);
  },
  runTestMode: function (charge) {
    var path = '/charges/' + charge.id;
    wx.request({
      url: this.PINGPP_NOTIFY_URL_BASE + path + '?livemode=false',
      success: function(res) {
        if (res.data == 'success') {
          callbacks.innerCallback('success');
        } else {
          callbacks.innerCallback('fail',
            callbacks.error('testmode_notify_fail'));
        }
      },
      fail:function() {
        callbacks.innerCallback('fail', callbacks.error('network_err'));
      }
    });
  }
};

var isv_lite = wx_lite;

var hasOwn$9 = {}.hasOwnProperty;
var isv_wap = {
  handleCharge: function (charge) {
    var extra = charge.extra;
    if (hasOwn$9.call(extra, 'pay_channel')) {
      var pay_channel = extra.pay_channel;
      if (pay_channel === 'wx' && !utils_1.inWeixin()) {
        callbacks.innerCallback('fail',
          callbacks.error('Not in the WeChat browser'));
        return;
      } else if (pay_channel === 'alipay' && !utils_1.inAlipay()) {
        callbacks.innerCallback('fail',
          callbacks.error('Not in the Alipay browser'));
        return;
      }
    } else {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_charge', 'charge 格式不正确'));
      return;
    }
    redirect_base.handleCharge(charge);
  }
};

var hasOwn$8 = {}.hasOwnProperty;
var jdpay_wap = {
  JDPAY_WAP_URL_OLD: 'https://m.jdpay.com/wepay/web/pay',
  JDPAY_H5_URL: 'https://h5pay.jd.com/jdpay/saveOrder',
  JDPAY_PC_URL: 'https://wepay.jd.com/jdpay/saveOrder',
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    var request_url = this.JDPAY_H5_URL;
    if (hasOwn$8.call(credential, 'channelUrl')) {
      request_url = credential.channelUrl;
      delete credential.channelUrl;
    } else if (hasOwn$8.call(credential, 'merchantRemark')) {
      request_url = this.JDPAY_WAP_URL_OLD;
    }
    utils_1.formSubmit(request_url, 'post', credential);
  }
};

var pab_pc = {
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    var request_url = credential.channelUrl;
    delete credential.channelUrl;
    utils_1.formSubmit(request_url, 'post', credential);
  }
};

var paypal = {
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    utils_1.redirectTo(credential, charge.channel);
  }
};

var hasOwn$7 = {}.hasOwnProperty;
var qpay_pub = {
  SRC_URL: 'https://open.mobile.qq.com/sdk/qqapi.js?_bid=152',
  ID: 'mqq_api',
  handleCharge: function (charge) {
    var credential = charge.credential[charge.channel];
    if (!hasOwn$7.call(credential, 'token_id')) {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_credential', 'missing_token_id'));
      return;
    }
    stash.tokenId = credential.token_id;
    utils_1.loadUrlJs(this.ID, this.SRC_URL, this.callpay);
  },
  callpay: function () {
    if (typeof mqq != 'undefined') {
      if (mqq.QQVersion == 0) {
        callbacks.innerCallback('fail',
          callbacks.error('Not in the QQ client'));
        delete stash.tokenId;
        return;
      }
      mqq.tenpay.pay({
        tokenId: stash.tokenId
      }, function (result) {
        if (result.resultCode == 0) {
          callbacks.innerCallback('success');
        } else {
          callbacks.innerCallback('fail',
            callbacks.error(result.retmsg));
        }
      });
    } else {
      callbacks.innerCallback('fail',
        callbacks.error('network_err'));
    }
    delete stash.tokenId;
  }
};

var hasOwn$6 = {}.hasOwnProperty;
var upacp_b2b = {
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    var baseURL;
    if (hasOwn$6.call(credential, 'channel_url')) {
      baseURL = credential.channel_url;
      delete credential.channel_url;
    }
    utils_1.formSubmit(baseURL, 'post', credential);
  }
};

var upacp_pc = {
  UPACP_PC_URL: 'https://gateway.95516.com/gateway/api/frontTransReq.do',
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    utils_1.formSubmit(this.UPACP_PC_URL, 'post', credential);
  }
};

var upacp_wap = {
  UPACP_WAP_URL: 'https://gateway.95516.com/gateway/api/frontTransReq.do',
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    utils_1.formSubmit(this.UPACP_WAP_URL, 'post', credential);
  }
};

var wx_lite_pab = wx_lite;

var hasOwn$5 = {}.hasOwnProperty;
var wx_pub = {
  PINGPP_NOTIFY_URL_BASE: 'https://notify.pingxx.com/notify',
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    var fields = [
      'appId', 'timeStamp', 'nonceStr', 'package', 'signType', 'paySign'
    ];
    for (var k = 0; k < fields.length; k++) {
      if (!hasOwn$5.call(credential, fields[k])) {
        callbacks.innerCallback('fail',
          callbacks.error('invalid_credential', 'missing_field_' + fields[k]));
        return;
      }
    }
    stash.jsApiParameters = credential;
    this.callpay();
  },
  callpay: function() {
    var self = this;
    var wx_jssdk = mods_1.getExtraModule('wx_jssdk');
    if (typeof wx_jssdk !== 'undefined' && wx_jssdk.jssdkEnabled()) {
      wx_jssdk.callpay();
    } else if (typeof WeixinJSBridge == 'undefined') {
      var eventCallback = function() {
        self.jsApiCall();
      };
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady',
          eventCallback, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', eventCallback);
        document.attachEvent('onWeixinJSBridgeReady', eventCallback);
      }
    } else {
      this.jsApiCall();
    }
  },
  jsApiCall: function() {
    if (hasOwn$5.call(stash, 'jsApiParameters')) {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        stash.jsApiParameters,
        function(res) {
          delete stash.jsApiParameters;
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            callbacks.innerCallback('success');
          } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
            callbacks.innerCallback('cancel');
          } else {
            callbacks.innerCallback('fail',
              callbacks.error('wx_result_fail', res.err_msg));
          }
        }
      );
    }
  },
  runTestMode: function(charge) {
    var dopay = confirm('模拟付款？');
    if (dopay) {
      var path = '/charges/' + charge.id;
      utils_1.request(this.PINGPP_NOTIFY_URL_BASE + path + '?livemode=false',
        'GET', null,
        function(data, status) {
          if (status >= 200 && status < 400 && data == 'success') {
            callbacks.innerCallback('success');
          } else {
            var extra = 'http_code:' + status + ';response:' + data;
            callbacks.innerCallback('fail',
              callbacks.error('testmode_notify_fail', extra));
          }
        },
        function() {
          callbacks.innerCallback('fail', callbacks.error('network_err'));
        });
    }
  }
};

var wx_pub_hzbank = wx_pub;

var wx_pub_pab = wx_pub;

var hasOwn$4 = {}.hasOwnProperty;
var wx_wap = {
  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    if (typeof credential === 'string') {
      utils_1.redirectTo(credential, charge.channel);
    } else if (typeof credential === 'object'
      && hasOwn$4.call(credential, 'url')
    ) {
      utils_1.redirectTo(credential.url, charge.channel);
    } else {
      callbacks.innerCallback('fail',
        callbacks.error('invalid_credential', 'credential 格式不正确'));
    }
  }
};

var hasOwn$3 = {}.hasOwnProperty;
var yeepay_wap = {
  YEEPAY_WAP_URL: 'https://ok.yeepay.com/paymobile/api/pay/request',
  YEEPAY_WAP_TEST_URL: 'http://mobiletest.yeepay.com/paymobile/api/pay/request',
  handleCharge: function(charge) {
    var channel = charge.channel;
    var credential = charge.credential[channel];
    var fields = ['merchantaccount', 'encryptkey', 'data'];
    for (var k = 0; k < fields.length; k++) {
      if (!hasOwn$3.call(credential, fields[k])) {
        callbacks.innerCallback('fail',
          callbacks.error('invalid_credential', 'missing_field_' + fields[k]));
        return;
      }
    }
    var baseURL;
    if (hasOwn$3.call(credential, 'mode') && credential.mode == 'test') {
      baseURL = this.YEEPAY_WAP_TEST_URL;
    } else {
      baseURL = this.YEEPAY_WAP_URL;
    }
    utils_1.redirectTo(baseURL + '?' +
      utils_1.stringifyData(credential, channel, true), charge.channel);
  }
};

var ap = createCommonjsModule(function (module) {
var hasOwn = {}.hasOwnProperty;
(function() {
  var b = {};
  var a = {};
  a.PADCHAR = '=';
  a.ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  a.makeDOMException = function() {
    try {
      return new DOMException(DOMException.INVALID_CHARACTER_ERR);
    } catch (d) {
      var c = new Error('DOM Exception 5');
      c.code = c.number = 5;
      c.name = c.description = 'INVALID_CHARACTER_ERR';
      c.toString = function() {
        return 'Error: ' + c.name + ': ' + c.message;
      };
      return c;
    }
  };
  a.getbyte64 = function(e, d) {
    var c = a.ALPHA.indexOf(e.charAt(d));
    if (c === -1) {
      throw a.makeDOMException();
    }
    return c;
  };
  a.decode = function(f) {
    f = '' + f;
    var j = a.getbyte64;
    var h, e, g;
    var d = f.length;
    if (d === 0) {
      return f;
    }
    if (d % 4 !== 0) {
      throw a.makeDOMException();
    }
    h = 0;
    if (f.charAt(d - 1) === a.PADCHAR) {
      h = 1;
      if (f.charAt(d - 2) === a.PADCHAR) {
        h = 2;
      }
      d -= 4;
    }
    var c = [];
    for (e = 0; e < d; e += 4) {
      g = (j(f, e) << 18) |
        (j(f, e + 1) << 12) |
        (j(f, e + 2) << 6) |
        j(f, e + 3);
      c.push(String.fromCharCode(g >> 16, (g >> 8) & 255, g & 255));
    }
    switch (h) {
      case 1:
        g = (j(f, e) << 18) | (j(f, e + 1) << 12) | (j(f, e + 2) << 6);
        c.push(String.fromCharCode(g >> 16, (g >> 8) & 255));
        break;
      case 2:
        g = (j(f, e) << 18) | (j(f, e + 1) << 12);
        c.push(String.fromCharCode(g >> 16));
        break;
    }
    return c.join('');
  };
  a.getbyte = function(e, d) {
    var c = e.charCodeAt(d);
    if (c > 255) {
      throw a.makeDOMException();
    }
    return c;
  };
  a.encode = function(f) {
    if (arguments.length !== 1) {
      throw new SyntaxError('Not enough arguments');
    }
    var g = a.PADCHAR;
    var h = a.ALPHA;
    var k = a.getbyte;
    var e, j;
    var c = [];
    f = '' + f;
    var d = f.length - f.length % 3;
    if (f.length === 0) {
      return f;
    }
    for (e = 0; e < d; e += 3) {
      j = (k(f, e) << 16) | (k(f, e + 1) << 8) | k(f, e + 2);
      c.push(h.charAt(j >> 18));
      c.push(h.charAt((j >> 12) & 63));
      c.push(h.charAt((j >> 6) & 63));
      c.push(h.charAt(j & 63));
    }
    switch (f.length - d) {
      case 1:
        j = k(f, e) << 16;
        c.push(h.charAt(j >> 18) + h.charAt((j >> 12) & 63) + g + g);
        break;
      case 2:
        j = (k(f, e) << 16) | (k(f, e + 1) << 8);
        c.push(h.charAt(j >> 18) +
          h.charAt((j >> 12) & 63) +
          h.charAt((j >> 6) & 63) + g);
        break;
    }
    return c.join('');
  };
  b.url = 'pay.htm';
  b.pay = function(d) {
    var c = encodeURIComponent(a.encode(d));
    if (hasOwn.call(stash, 'APURL')) {
      b.url = stash.APURL;
    }
    location.href = b.url + '?goto=' + c;
  };
  b.decode = function(c) {
    return a.decode(decodeURIComponent(c));
  };
  module.exports = b;
})();
});

var hasOwn$2 = {}.hasOwnProperty;
var agreement = {
  signAgreement: function (agreement) {
    var agreementObj;
    if (typeof agreement === 'string') {
      try {
        agreementObj = JSON.parse(agreement);
      } catch (err) {
        callbacks.innerAgreementCallback('fail',
          callbacks.error('json_decode_fail', err));
        return false;
      }
    } else {
      agreementObj = agreement;
    }
    if (typeof agreementObj === 'undefined') {
      callbacks.innerAgreementCallback('fail',
        callbacks.error('json_decode_fail'));
      return false;
    }
    if (!hasOwn$2.call(agreementObj, 'object')
      || agreementObj.object !== 'agreement'
      || !hasOwn$2.call(agreementObj, 'channel')
      || !hasOwn$2.call(agreementObj, 'credential')
      || typeof agreementObj.credential !== 'object'
    ) {
      callbacks.innerAgreementCallback('fail',
        callbacks.error('invalid_object'));
      return false;
    }
    if (!hasOwn$2.call(agreementObj.credential, agreementObj.channel)) {
      callbacks.innerAgreementCallback('fail',
        callbacks.error('invalid_credential'));
      return false;
    }
    var credential = agreementObj.credential[agreementObj.channel];
    var urlToOpen;
    if (typeof credential === 'string') {
      urlToOpen = credential;
    } else if (hasOwn$2.call(credential, 'credential')
      && typeof credential.credential === 'string'
    ) {
      urlToOpen = credential.credential;
    }
    if (typeof urlToOpen === 'undefined') {
      callbacks.innerAgreementCallback('fail',
        callbacks.error('invalid_credential'));
      return false;
    }
    if (agreementObj.channel.substring(0, 6) === 'alipay') {
      var url = new URL(urlToOpen);
      urlToOpen = 'http://d.alipay.com/i/index.htm?iframeSrc='
        + encodeURIComponent('alipays://platformapi/startapp?appId=60000157'
          +'&appClearTop=false&startMultApp=YES&sign_params='
          + encodeURIComponent(url.search.substring(1))
        );
    }
    setTimeout(function() {
      utils_1.redirectTo(urlToOpen);
    }, 0);
    return true;
  }
};

var hasOwn$1 = {}.hasOwnProperty;
var mods = {};
var mods_1 = mods;
mods.channels = {
  alipay: alipay,
  alipay_lite: alipay_lite,
  alipay_pc_direct: alipay_pc_direct,
  alipay_qr: alipay_qr,
  alipay_qr_lakala: alipay_qr_lakala,
  alipay_wap: alipay_wap,
  alipay_wap_lakala: alipay_wap_lakala,
  bfb_wap: bfb_wap,
  cb_alipay_pc_direct: cb_alipay_pc_direct,
  cb_alipay_wap: cb_alipay_wap,
  cb_wx_pub: cb_wx_pub,
  ccb_qr: ccb_qr,
  ccb_wap: ccb_wap,
  cmb_pc_qr: cmb_pc_qr,
  cmb_wallet: cmb_wallet,
  coolcredit: coolcredit,
  cp_b2b: cp_b2b,
  isv_lite: isv_lite,
  isv_wap: isv_wap,
  jdpay_wap: jdpay_wap,
  pab_pc: pab_pc,
  paypal: paypal,
  qpay_pub: qpay_pub,
  upacp_b2b: upacp_b2b,
  upacp_pc: upacp_pc,
  upacp_wap: upacp_wap,
  wx_lite: wx_lite,
  wx_lite_pab: wx_lite_pab,
  wx_pub: wx_pub,
  wx_pub_hzbank: wx_pub_hzbank,
  wx_pub_pab: wx_pub_pab,
  wx_wap: wx_wap,
  yeepay_wap: yeepay_wap
};
mods.extras = {
  ap: ap,
  agreement: agreement
};
mods.getChannelModule = function(channel) {
  if (hasOwn$1.call(mods.channels, channel)) {
    return mods.channels[channel];
  }
  return undefined;
};
mods.getExtraModule = function(name) {
  if (hasOwn$1.call(mods.extras, name)) {
    return mods.extras[name];
  }
  return undefined;
};

var version = version$1.v;
var hasOwn = {}.hasOwnProperty;
var PingppSDK = function () {
  init.init();
};
PingppSDK.prototype.version = version;
var main = new PingppSDK();
var PingppError = errors.Error;
PingppSDK.prototype.createPayment = function (
  chargeJSON, callback, signature, debug
) {
  if (typeof callback === 'function') {
    callbacks.userCallback = callback;
  }
  try {
    payment_elements.init(chargeJSON);
  } catch (e) {
    if (e instanceof PingppError) {
      callbacks.innerCallback('fail',
        callbacks.error(e.message, e.extra));
      return;
    } else {
      throw e;
    }
  }
  if (!hasOwn.call(payment_elements, 'id')) {
    callbacks.innerCallback('fail',
      callbacks.error('invalid_charge', 'no_charge_id'));
    return;
  }
  if (!hasOwn.call(payment_elements, 'channel')) {
    callbacks.innerCallback('fail',
      callbacks.error('invalid_charge', 'no_channel'));
    return;
  }
  if (hasOwn.call(payment_elements, 'app')) {
    if (typeof payment_elements.app === 'string') {
      stash.app_id = payment_elements.app;
    } else if (typeof payment_elements.app === 'object' &&
      typeof payment_elements.app.id === 'string') {
      stash.app_id = payment_elements.app.id;
    }
  }
  var channel = payment_elements.channel;
  if (!hasOwn.call(payment_elements, 'credential')) {
    callbacks.innerCallback('fail',
      callbacks.error('invalid_charge', 'no_credential'));
    return;
  }
  if (payment_elements.paid && payment_elements.actual_amount === 0) {
    callbacks.innerCallback('success');
    return;
  }
  if (!payment_elements.credential) {
    callbacks.innerCallback('fail',
      callbacks.error('invalid_credential', 'credential_is_undefined'));
    return;
  }
  if (!hasOwn.call(payment_elements.credential, channel)) {
    callbacks.innerCallback('fail',
      callbacks.error('invalid_credential', 'credential_is_incorrect'));
    return;
  }
  if (!hasOwn.call(payment_elements, 'livemode')) {
    callbacks.innerCallback('fail',
      callbacks.error('invalid_charge', 'no_livemode_field'));
    return;
  }
  var channelModule = mods_1.getChannelModule(channel);
  if (typeof channelModule === 'undefined') {
    console.error('channel module "' + channel + '" is undefined');
    callbacks.innerCallback('fail',
      callbacks.error('invalid_channel',
        'channel module "' + channel + '" is undefined')
    );
    return;
  }
  if (payment_elements.livemode === false) {
    if (hasOwn.call(channelModule, 'runTestMode')) {
      channelModule.runTestMode(payment_elements);
    } else {
      testmode.runTestMode(payment_elements);
    }
    return;
  }
  if (typeof signature != 'undefined') {
    stash.signature = signature;
  }
  if (typeof debug == 'boolean') {
    stash.debug = debug;
  }
  channelModule.handleCharge(payment_elements);
};
PingppSDK.prototype.setAPURL = function (url) {
  stash.APURL = url;
};
PingppSDK.prototype.setUrlReturnCallback = function (callback, channels) {
  if (typeof callback === 'function') {
    callbacks.urlReturnCallback = callback;
  } else {
    throw 'callback need to be a function';
  }
  if (typeof channels !== 'undefined') {
    if (Array.isArray(channels)) {
      callbacks.urlReturnChannels = channels;
    } else {
      throw 'channels need to be an array';
    }
  }
};
PingppSDK.prototype.signAgreement = function (agreement, callback) {
  if (typeof callback === 'function') {
    callbacks.userAgreementCallback = callback;
  }
  var module = mods_1.getExtraModule('agreement');
  if (typeof module === 'undefined') {
    console.error('module "agreement" is undefined');
    callbacks.innerCallback('fail',
      callbacks.error('invalid_module',
        'module "agreement" is undefined')
    );
    return false;
  }
  return module.signAgreement(agreement);
};

function pingPay(payString) {
    Telescope.trackLog({ trackId: 'checkout-sdk-pay-pingpp-begin', custom: { payString: payString } });
    return new Promise(function (resolve, reject) {
        main.createPayment(payString, function (result, err) {
            if (EPayResult[result] === EPayResult.success) {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-pingpp-success', custom: { result: result } });
                resolve();
                return;
            }
            var title = '支付失败，用户非法操作';
            var error = EPayResult[result] || result;
            if (!result) {
                title = '支付失败，ping++内部错误';
                error = err;
            }
            Telescope.trackLog({ trackId: 'checkout-sdk-pay-pingpp-fail', custom: { title: title, error: error } });
            reject(error);
        });
    });
}
function appPay(payString, payWay) {
    Telescope.trackLog({ trackId: 'checkout-sdk-pay-app-begin', custom: { payString: payString } });
    return new Promise(function (resolve, reject) {
        Sailer[PAY_WAY[payWay] || payWay](getAppPayString(payString), function (result) {
            var _a = result.data, data = _a === void 0 ? 0 : _a;
            if (EPayResult.success === EPayResult[data]) {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-app-success', custom: { result: result } });
                resolve();
                return;
            }
            Telescope.trackLog({ trackId: 'checkout-sdk-pay-app-fail', custom: { result: result } });
            reject(EPayResult[data] || EPayResult[0]);
        }, function (d) {
            var res = (d && d.data) || 0;
            Telescope.trackLog({ trackId: 'checkout-sdk-pay-app-sailer-fail', custom: { d: d } });
            reject(EPayResult[res]);
        });
    });
}
function wxAppPay(payStringJson) {
    var _a = JSON.parse(payStringJson), appid = _a.app_id, partnerid = _a.mch_id, prepayid = _a.prepay_id, noncestr = _a.nonce_str, timestamp = _a.time_stamp, sign = _a.sign;
    return wxAppNativePay({ appid: appid, partnerid: partnerid, prepayid: prepayid, noncestr: noncestr, timestamp: timestamp, sign: sign });
}
function wxAppNativePay(payParams) {
    Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-app-begin', custom: { payParams: payParams } });
    return new Promise(function (resolve, reject) {
        Sailer.wxsdkpay(payParams, function (result) {
            var _a = result.data, data = _a === void 0 ? 0 : _a;
            if (data === 2) {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-app-error', custom: { error: '请先安装微信' } });
                reject('请先安装微信');
                return;
            }
            if (EPayResult.success === EPayResult[data]) {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-app-success', custom: { result: result } });
                resolve();
                return;
            }
            Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-app-error', custom: { error: 'app支付失败', result: result } });
            reject(EPayResult[data] || EPayResult[0]);
        }, function (d) {
            var res = (d && d.data) || 0;
            Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-app-sailer-fail', custom: { error: 'Sailer调用异常', d: d } });
            reject(EPayResult[res]);
        });
    });
}
function wxPay(payStringJson) {
    var _a = JSON.parse(payStringJson), appId = _a.app_id, nonceStr = _a.nonce_str, packageValue = _a.package_value, timeStamp = _a.time_stamp, paySign = _a.sign, signType = _a.sign_type;
    return wxNativePay({
        appId: appId,
        package: packageValue,
        nonceStr: nonceStr,
        timeStamp: timeStamp,
        signType: signType,
        paySign: paySign
    });
}
function wxNativePay(payParams) {
    Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-native-begin', custom: { payParams: payParams } });
    return new Promise(function (resolve, reject) {
        WeixinJSBridge.invoke('getBrandWCPayRequest', payParams, function (res) {
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-native-success', custom: { error: '微信原生支付成功', res: res } });
                resolve();
            }
            else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-native-fail', custom: { error: '微信原生支付失败', res: res } });
                reject(EPayResult.fail);
            }
        });
    });
}
function wxMiniPay(payString) {
    var paramKeys = ['timeStamp', 'nonceStr', 'packageValue', 'sign', 'signType'];
    var _a = getPaymentParams(payString, paramKeys), timeStamp = _a.timeStamp, nonceStr = _a.nonceStr, packageValue = _a.packageValue, paySign = _a.sign, signType = _a.signType;
    Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-mini-begin', custom: { payString: payString } });
    return new Promise(function (resolve, reject) {
        wx.requestPayment({
            timeStamp: timeStamp,
            nonceStr: nonceStr,
            package: packageValue,
            signType: signType,
            paySign: paySign,
            success: function (res) {
                resolve();
            },
            fail: function (err) {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-wx-mini-fail', custom: { error: '微信小程序支付失败', err: err } });
                reject(EPayResult.fail);
            }
        });
    });
}

var PrePay = (function (_super) {
    __extends(PrePay, _super);
    function PrePay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrePay.prototype.getPayConfigs = function (tradeNo) {
        return __awaiter(this, void 0, void 0, function () {
            var payConfigs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.adapter) {
                            return [2, Promise.reject(PAY_ERROR.initAdaptError)];
                        }
                        return [4, this.getPayConfigList(tradeNo, this.payUA)];
                    case 1:
                        payConfigs = _a.sent();
                        if (env.inWechat) {
                            payConfigs = payConfigs.filter(function (item) { return item.payClient !== 'alipay'; });
                        }
                        if (env.inAliApp) {
                            payConfigs = payConfigs.filter(function (item) { return item.payClient !== 'wechat'; });
                        }
                        return [2, payConfigs.map(function (item) {
                                return __assign(__assign({}, item), getPayClient(item.payClient));
                            })];
                }
            });
        });
    };
    PrePay.prototype.toPay = function (payConfig, payParam) {
        return __awaiter(this, void 0, void 0, function () {
            var now, tradeNo, _a, redirectUrl, _b, failUrl, _c, successUrl, configKey, bizOpenId, _d, payString, status_1, payStringJson, successCallBack, error_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.adapter) {
                            return [2, Promise.reject(PAY_ERROR.initAdaptError)];
                        }
                        now = Date.now();
                        Telescope.trackLog({ trackId: 'checkout-sdk-to-pay', custom: { time: now, payParam: payParam, payConfig: payConfig } });
                        tradeNo = payParam.tradeNo, _a = payParam.redirectUrl, redirectUrl = _a === void 0 ? '' : _a, _b = payParam.failUrl, failUrl = _b === void 0 ? '' : _b, _c = payParam.successUrl, successUrl = _c === void 0 ? '' : _c;
                        this.tradeNo = tradeNo;
                        this.redirectUrl = redirectUrl;
                        if (failUrl) {
                            this.options.failUrl = failUrl;
                        }
                        if (successUrl) {
                            this.options.successUrl = successUrl;
                        }
                        if (!(env.inWechat && !this.options.needLogin)) return [3, 2];
                        configKey = this.options.configKey;
                        if (!configKey) {
                            throw new CheckoutError('configKey参数为必传项');
                        }
                        this.options.bizToken = getQueryVariable('token');
                        if (!this.options.bizToken && configKey) {
                            return [2, baseOfWechat(configKey, payConfig.payWay)];
                        }
                        if (!this.options.bizToken) return [3, 2];
                        ZYToast.setOnceConfig({ noToast: true });
                        return [4, getNoLoginOpenId({
                                bizToken: this.options.bizToken,
                                bizId: this.options.bizId
                            })];
                    case 1:
                        bizOpenId = (_e.sent()).data.bizOpenId;
                        this.bizOpenId = bizOpenId;
                        ZYToast.clearOnceConfig();
                        _e.label = 2;
                    case 2:
                        Telescope.trackLog({ trackId: 'checkout-sdk-to-pay-options', custom: { options: this.options } });
                        _e.label = 3;
                    case 3:
                        _e.trys.push([3, 6, , 7]);
                        return [4, this.getRedirectUrl(payConfig)];
                    case 4:
                        _e.sent();
                        return [4, this.queryPayString(payConfig)];
                    case 5:
                        _d = _e.sent(), payString = _d.payString, status_1 = _d.status, payStringJson = _d.payStringJson;
                        successCallBack = payParam.successCallBack;
                        if (status_1 === 2) {
                            try {
                                if (successCallBack) {
                                    successCallBack();
                                }
                                replace(this.redirectUrl);
                                return [2, ''];
                            }
                            catch (error) {
                                Telescope.trackLog({
                                    trackId: 'checkout-sdk-pay-zero-success-call-back-error',
                                    custom: { error: error, redirectUrl: this.redirectUrl, time: Date.now() }
                                });
                            }
                        }
                        if (payConfig.payWay === NX_INSURE_PUB) {
                            return [2, Promise.reject(new CheckoutError('不符合医保支付要求，请选择其他支付方式', ERROR_TYPE.errorNotSupport))];
                        }
                        return [2, this.callPayChannel(payString, payConfig, payStringJson || '', successCallBack)];
                    case 6:
                        error_1 = _e.sent();
                        Telescope.trackLog({ trackId: 'checkout-sdk-to-pay-error', custom: { redirectUrl: redirectUrl, interval: Date.now() - now, error: error_1 } });
                        if (error_1 instanceof CheckoutError) {
                            throw error_1;
                        }
                        throw new CheckoutError(error_1);
                    case 7: return [2];
                }
            });
        });
    };
    PrePay.prototype.prePay = function (payParam) {
        return __awaiter(this, void 0, void 0, function () {
            var now, tradeNo, _a, redirectUrl, payConfigs, payWay_1, selectedPayConfig, payConfigList, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.adapter) {
                            return [2, Promise.reject(PAY_ERROR.initAdaptError)];
                        }
                        now = Date.now();
                        tradeNo = payParam.tradeNo, _a = payParam.redirectUrl, redirectUrl = _a === void 0 ? '' : _a;
                        Telescope.trackLog({ trackId: 'checkout-sdk-pre-pay', custom: { time: now, redirectUrl: redirectUrl, tradeNo: tradeNo } });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, this.getPayConfigs(tradeNo)];
                    case 2:
                        payConfigs = _b.sent();
                        payWay_1 = this.options.payWay;
                        selectedPayConfig = void 0;
                        if (payWay_1 && payWay_1.length > 0) {
                            payConfigList = payConfigs.filter(function (el) { return payWay_1.includes(el.payWay); });
                            if (!payConfigList || payConfigList.length === 0) {
                                Telescope.trackLog({ trackId: 'checkout-sdk-pre-pay', custom: { interval: Date.now() - now, title: '没有配置支付方式' } });
                                return [2, Promise.reject('没有配置支付方式')];
                            }
                            selectedPayConfig = payConfigList[0];
                        }
                        else {
                            selectedPayConfig = payConfigs[0];
                        }
                        return [2, this.toPay(selectedPayConfig, payParam)];
                    case 3:
                        error_2 = _b.sent();
                        Telescope.trackLog({ trackId: 'checkout-sdk-pre-pay-error', custom: { redirectUrl: redirectUrl, interval: Date.now() - now, error: error_2 } });
                        return [2, Promise.reject(error_2)];
                    case 4: return [2];
                }
            });
        });
    };
    PrePay.prototype.getRedirectUrl = function (payConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var now, callbackRedirectUrl, _a, successUrl, failUrl, domain, backEventType, bizId, needLogin, bizSource, configRedirectUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        now = Date.now();
                        callbackRedirectUrl = '';
                        if (env.inH5 && payConfig.payWay === EPingPayWay.wechatH5) {
                            callbackRedirectUrl = window.location.href + "&finishPay=true";
                        }
                        else {
                            _a = this.options, successUrl = _a.successUrl, failUrl = _a.failUrl, domain = _a.domain, backEventType = _a.backEventType, bizId = _a.bizId, needLogin = _a.needLogin, bizSource = _a.bizSource;
                            callbackRedirectUrl =
                                this.redirectUrl ||
                                    callBackUrl(domain, {
                                        tradeNo: this.tradeNo,
                                        bizId: bizId,
                                        bizSource: bizSource,
                                        login: String(needLogin),
                                        successUrl: successUrl,
                                        backEventType: backEventType,
                                        failUrl: failUrl
                                    });
                        }
                        return [4, getRedirectUrl(callbackRedirectUrl)];
                    case 1:
                        configRedirectUrl = (_b.sent()).data;
                        this.redirectUrl = configRedirectUrl;
                        Telescope.trackLog({
                            trackId: 'checkout-sdk-redirect-url',
                            custom: { redirectUrl: this.redirectUrl, time: Date.now(), interval: Date.now() - now }
                        });
                        return [2];
                }
            });
        });
    };
    PrePay.prototype.getPayQRCode = function (tradeNo, payWays) {
        if (payWays === void 0) { payWays = []; }
        return __awaiter(this, void 0, void 0, function () {
            var now, payConfigs, payConfigList, result, _i, payConfigList_1, item, _a, payString, payStringJson, payChannel, payQrPicUrl, serverTimeSecond, code_url, _b, channel, credential, error_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.adapter) {
                            return [2, Promise.reject(PAY_ERROR.initAdaptError)];
                        }
                        now = Date.now();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 8, , 9]);
                        return [4, this.getPayConfigList(tradeNo, 'native')];
                    case 2:
                        payConfigs = _c.sent();
                        payConfigList = [];
                        if (payWays && payWays.length > 0) {
                            payConfigList.push.apply(payConfigList, payConfigs.filter(function (item) { return payWays.includes(item.payWay); }));
                        }
                        else {
                            payConfigList.push.apply(payConfigList, payConfigs);
                        }
                        if (!(payConfigList && payConfigList.length > 0)) return [3, 7];
                        result = {};
                        _i = 0, payConfigList_1 = payConfigList;
                        _c.label = 3;
                    case 3:
                        if (!(_i < payConfigList_1.length)) return [3, 6];
                        item = payConfigList_1[_i];
                        return [4, getPayString(__assign(__assign({}, item), { tradeNo: tradeNo, payUA: 'native', productId: tradeNo }))];
                    case 4:
                        _a = (_c.sent()).data, payString = _a.payString, payStringJson = _a.payStringJson, payChannel = _a.payChannel, payQrPicUrl = _a.payQrPicUrl, serverTimeSecond = _a.serverTimeSecond;
                        if (payChannel === 'wxpay_ecommerce') {
                            if (!!payQrPicUrl) {
                                result['wechat'] = payQrPicUrl;
                                result['payStringJson'] = __assign(__assign({}, (JSON.parse(payStringJson) || {})), { serverTimeSecond: serverTimeSecond });
                            }
                            else {
                                code_url = JSON.parse(payStringJson).code_url;
                                result['wechat'] = code_url;
                            }
                        }
                        else {
                            _b = JSON.parse(payString), channel = _b.channel, credential = _b.credential;
                            result[EQRCodePayWay[channel]] = credential[channel];
                        }
                        _c.label = 5;
                    case 5:
                        _i++;
                        return [3, 3];
                    case 6:
                        Telescope.trackLog({ trackId: 'checkout-sdk-pay-qrCode', custom: { payWays: payWays, interval: Date.now() - now, result: result, payConfigList: payConfigList } });
                        return [2, Promise.resolve(result)];
                    case 7: return [2, Promise.resolve({})];
                    case 8:
                        error_3 = _c.sent();
                        Telescope.trackLog({ trackId: 'checkout-sdk-pay-qrCode-error', custom: { payWays: payWays, interval: Date.now() - now, error: error_3 } });
                        return [2, Promise.reject(error_3)];
                    case 9: return [2];
                }
            });
        });
    };
    PrePay.prototype.getPayConfigList = function (tradeNo, payUA) {
        return __awaiter(this, void 0, void 0, function () {
            var now, _a, configList, message, error_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        now = Date.now();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, getPayConfig(tradeNo, payUA)];
                    case 2:
                        _a = _b.sent(), configList = _a.data, message = _a.message;
                        if (!configList && message) {
                            Telescope.trackLog({ trackId: 'checkout-sdk-pay-config-error', custom: { message: message, time: Date.now() - now } });
                            return [2, Promise.reject(new Error(message))];
                        }
                        Telescope.trackLog({ trackId: 'checkout-sdk-pay-config', custom: { time: Date.now() - now, configList: __spreadArrays(configList) } });
                        return [2, configList];
                    case 3:
                        error_4 = _b.sent();
                        Telescope.trackLog({ trackId: 'checkout-sdk-pay-config-error', custom: error_4 });
                        return [2, Promise.reject(error_4)];
                    case 4: return [2];
                }
            });
        });
    };
    PrePay.prototype.queryPayString = function (payConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var now, payData, payString, status_2, payStringJson, error_5, code;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ZYToast.setOnceConfig({ noToast: true });
                        now = Date.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, getPayString(__assign(__assign({}, payConfig), { redirectUrl: this.redirectUrl, tradeNo: this.tradeNo, bizOpenId: this.bizOpenId, payUA: this.payUA }))];
                    case 2:
                        payData = (_a.sent()).data;
                        payString = payData.payString, status_2 = payData.status, payStringJson = payData.payStringJson;
                        Telescope.trackLog({
                            trackId: 'checkout-sdk-pay-string',
                            custom: { payString: payString, status: status_2, payStringJson: payStringJson, time: Date.now(), interval: Date.now() - now }
                        });
                        return [2, { payString: payString, status: status_2, payStringJson: payStringJson }];
                    case 3:
                        error_5 = _a.sent();
                        Telescope.trackLog({ trackId: 'checkout-sdk-pay-string-error', custom: error_5 });
                        code = ['102002004', '102002005', '102002006'].indexOf(error_5.code) > -1 ? error_5.code : '';
                        throw new CheckoutError(error_5.message, ERROR_TYPE.errorDialog, code);
                    case 4: return [2];
                }
            });
        });
    };
    PrePay.prototype.callPayChannel = function (payString, _a, payStringJson, successCallBack) {
        var _this = this;
        var payWay = _a.payWay, payChannel = _a.payChannel;
        if (successCallBack === void 0) { successCallBack = undefined; }
        Telescope.trackLog({
            trackId: 'checkout-sdk-pay-begin',
            custom: { redirectUrl: this.redirectUrl, time: Date.now(), payWay: payWay, payChannel: payChannel, payString: payString, payStringJson: payStringJson }
        });
        var PayFunction;
        if (this.payUA === 'app') {
            PayFunction = payChannel !== 'pingxxpay' ? wxAppPay : appPay;
        }
        else {
            PayFunction = payChannel !== 'pingxxpay' ? wxPay : pingPay;
        }
        return new Promise(function (resolve, reject) {
            PayFunction(payChannel !== 'pingxxpay' ? payStringJson : payString, payWay)
                .then(function () {
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-success', custom: { redirectUrl: _this.redirectUrl, time: Date.now() } });
                try {
                    if (successCallBack) {
                        successCallBack();
                    }
                }
                catch (error) {
                    Telescope.trackLog({
                        trackId: 'checkout-sdk-pay-success-call-back-error',
                        custom: { error: error, redirectUrl: _this.redirectUrl, time: Date.now() }
                    });
                }
                replace(_this.redirectUrl);
                resolve();
            })
                .catch(function (err) {
                if (typeof err === 'string' && ERROR_MESSAGE[err]) {
                    err = new Error(ERROR_MESSAGE[err]);
                }
                Telescope.trackLog({ trackId: 'checkout-sdk-pay-error', custom: { err: err, time: Date.now() } });
                reject(err);
            });
        });
    };
    PrePay.prototype.miniPrePay = function (tradeNo) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, payChannel, payWay, configId, payString;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        return [4, getPayConfig(tradeNo, 'mini')];
                    case 1:
                        _a = (_b.sent()).data[0], payChannel = _a.payChannel, payWay = _a.payWay, configId = _a.configId;
                        return [4, getPayString({
                                tradeNo: tradeNo,
                                payChannel: payChannel,
                                payWay: payWay,
                                configId: configId,
                                payUA: 'mini',
                                bizOpenId: this.bizOpenId,
                                redirectUrl: ''
                            })];
                    case 2:
                        payString = (_b.sent()).data.payString;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4, wxMiniPay(payString)];
                    case 4:
                        _b.sent();
                        return [2, Promise.resolve(tradeNo)];
                    case 5:
                        _b.sent();
                        return [2, Promise.reject('PAY_ERROR')];
                    case 6: return [3, 8];
                    case 7:
                        _b.sent();
                        return [2, Promise.reject('BIZ_ERROR')];
                    case 8: return [2];
                }
            });
        });
    };
    PrePay.prototype.toMiniPay = function (tradeNo) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, payChannel, payWay, configId, payString;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        return [4, getPayConfig(tradeNo, 'mini')];
                    case 1:
                        _a = (_b.sent()).data[0], payChannel = _a.payChannel, payWay = _a.payWay, configId = _a.configId;
                        return [4, getPayString({
                                tradeNo: tradeNo,
                                payChannel: payChannel,
                                payWay: payWay,
                                configId: configId,
                                payUA: 'mini',
                                bizOpenId: this.bizOpenId,
                                redirectUrl: ''
                            })];
                    case 2:
                        payString = (_b.sent()).data.payString;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4, wxMiniPay(payString)];
                    case 4:
                        _b.sent();
                        return [2, Promise.resolve(tradeNo)];
                    case 5:
                        _b.sent();
                        return [2, Promise.reject('PAY_ERROR')];
                    case 6: return [3, 8];
                    case 7:
                        _b.sent();
                        return [2, Promise.reject('BIZ_ERROR')];
                    case 8: return [2];
                }
            });
        });
    };
    PrePay.prototype.getMallSassOrderDetail = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getMallSaasDetail(params)];
                    case 1:
                        res = _a.sent();
                        if (res && res.pay_type_list && res.pay_type_list.length > 0) {
                            res.pay_type_list = res.pay_type_list.map(function (item) {
                                return __assign(__assign({}, item), getMallSassPayClient(item.id));
                            });
                        }
                        return [2, res];
                }
            });
        });
    };
    PrePay.prototype.toMallPay = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var tradeType, payString, PayFunction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Telescope.trackLog({ trackId: 'checkout-sdk-mall-pay-begin', custom: { time: Date.now() } });
                        tradeType = getMallTradeType();
                        return [4, getMallSaasPay(__assign(__assign({}, params), { tradeType: tradeType }))];
                    case 1:
                        payString = _a.sent();
                        if (tradeType === EMallSassTradeType.APP) {
                            PayFunction = wxAppNativePay;
                        }
                        else if (tradeType === EMallSassTradeType.OFFICIAL) {
                            PayFunction = wxNativePay;
                        }
                        else {
                            Telescope.trackLog({
                                trackId: 'checkout-sdk-mall-pay-error',
                                custom: { tradeType: tradeType, message: '商盟支付不支持在此环境下支付' }
                            });
                            return [2, Promise.reject('支付失败')];
                        }
                        return [2, new Promise(function (resolve, reject) {
                                PayFunction(payString)
                                    .then(function () {
                                    Telescope.trackLog({ trackId: 'checkout-sdk-mall-pay-success', custom: { time: Date.now() } });
                                    resolve();
                                })
                                    .catch(function (err) {
                                    Telescope.trackLog({ trackId: 'checkout-sdk-mall-pay-error', custom: err });
                                    reject(err);
                                });
                            })];
                }
            });
        });
    };
    PrePay.prototype.toMallMiniPay = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2];
        }); });
    };
    return PrePay;
}(BaseConfig));

var index = new PrePay();

export default index;
export { EMallSassTradeType, EPayResult, EPingPayWay, EQRCodePayWay, ERROR_MESSAGE, ERROR_TYPE, EventTypeEnum, MALL_SASS_SUBMIT_PAY_OVER_TIME, NX_INSURE_PUB, PAY_ERROR, PAY_WAY, ROUTE_PATH, adaptConfig, baseOfWechat, callBackUrl, getAppPayString, getCommonApi, getMallSaasDetail, getMallSaasPay, getMallSaasPayResult, getMallSassPayClient, getMallTradeType, getNoLoginOpenId, getOpenId, getPayClient, getPayConfig, getPayResult, getPayString, getPayUa, getPaymentParams, getQueryValues, getQueryVariable, getRedirectUrl, getTradeInfo, getUCLoginUrl, isWxH5Pay, mallRequestResult, parseParam, replace };
/* follow me on Github! @cjinhuo */
//# sourceMappingURL=pay.esm.js.map
